//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class AbsenceReadControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/people";
    }

    getAbsences(order: Order | undefined, offset: number | undefined, limit: number | undefined, startDate: Date | undefined, endDate: Date | undefined, lang: string | undefined, type: AbsenceTypeEnum | undefined, employeeIds: number[] | undefined, unitIds: number[] | undefined, roles: string[] | undefined, statuses: AbsenceStatusEnum[] | undefined): Promise<AbsenceListResultDto> {
        let url_ = this.baseUrl + "/absences?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (employeeIds === null)
            throw new Error("The parameter 'employeeIds' cannot be null.");
        else if (employeeIds !== undefined)
            employeeIds && employeeIds.forEach(item => { url_ += "employeeIds=" + encodeURIComponent("" + item) + "&"; });
        if (unitIds === null)
            throw new Error("The parameter 'unitIds' cannot be null.");
        else if (unitIds !== undefined)
            unitIds && unitIds.forEach(item => { url_ += "unitIds=" + encodeURIComponent("" + item) + "&"; });
        if (roles === null)
            throw new Error("The parameter 'roles' cannot be null.");
        else if (roles !== undefined)
            roles && roles.forEach(item => { url_ += "roles=" + encodeURIComponent("" + item) + "&"; });
        if (statuses === null)
            throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAbsences(_response);
        });
    }

    protected processGetAbsences(response: Response): Promise<AbsenceListResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AbsenceListResultDto>(null as any);
    }

    /**
     * @param employeeId Employee id or constant `me`
     * @param order (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param lang (optional) 
     * @param type (optional) 
     * @param statuses (optional) 
     */
    getEmployeeAbsences(employeeId: string, order: Order2 | undefined, offset: number | undefined, limit: number | undefined, startDate: Date | undefined, endDate: Date | undefined, lang: string | undefined, type: AbsenceTypeEnum | undefined, statuses: AbsenceStatusEnum[] | undefined): Promise<AbsenceListResultDto2> {
        let url_ = this.baseUrl + "/employees/{employeeId}/absences?";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (statuses === null)
            throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmployeeAbsences(_response);
        });
    }

    protected processGetEmployeeAbsences(response: Response): Promise<AbsenceListResultDto2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AbsenceListResultDto2>(null as any);
    }

    /**
     * @param employeeId Employee id or constant `me`
     * @param order (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @param lang (optional) 
     */
    getEmployeeUpcoming(employeeId: string, order: Order3 | undefined, offset: number | undefined, limit: number | undefined, lang: string | undefined): Promise<AbsenceListResultDto3> {
        let url_ = this.baseUrl + "/employees/{employeeId}/absences/upcoming?";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmployeeUpcoming(_response);
        });
    }

    protected processGetEmployeeUpcoming(response: Response): Promise<AbsenceListResultDto3> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AbsenceListResultDto3>(null as any);
    }

    /**
     * Capabilities=view-absence; Scopes=SELF
     * @param employeeId Employee id or constant `me`
     * @param order (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param lang (optional) 
     * @param treeId (optional) 
     * @param unitIds (optional) 
     * @param roles (optional) 
     * @param statuses (optional) 
     */
    getTeamAbsences(employeeId: string, order: Order4 | undefined, offset: number | undefined, limit: number | undefined, startDate: Date | undefined, endDate: Date | undefined, lang: string | undefined, treeId: string | undefined, unitIds: number[] | undefined, roles: string[] | undefined, statuses: AbsenceStatusEnum[] | undefined): Promise<AbsenceListResultDto4> {
        let url_ = this.baseUrl + "/employees/{employeeId}/team/absences?";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (treeId === null)
            throw new Error("The parameter 'treeId' cannot be null.");
        else if (treeId !== undefined)
            url_ += "treeId=" + encodeURIComponent("" + treeId) + "&";
        if (unitIds === null)
            throw new Error("The parameter 'unitIds' cannot be null.");
        else if (unitIds !== undefined)
            unitIds && unitIds.forEach(item => { url_ += "unitIds=" + encodeURIComponent("" + item) + "&"; });
        if (roles === null)
            throw new Error("The parameter 'roles' cannot be null.");
        else if (roles !== undefined)
            roles && roles.forEach(item => { url_ += "roles=" + encodeURIComponent("" + item) + "&"; });
        if (statuses === null)
            throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTeamAbsences(_response);
        });
    }

    protected processGetTeamAbsences(response: Response): Promise<AbsenceListResultDto4> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AbsenceListResultDto4>(null as any);
    }
}

export class EmployeeReadControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/people";
    }

    getEmployees(order: Order5 | undefined, offset: number | undefined, limit: number | undefined, lang: string | undefined, statuses: EmployeeStatusEnum[] | undefined, roles: string[] | undefined, unitIds: number[] | undefined, employeeIds: number[] | undefined): Promise<EmployeeListResultDto> {
        let url_ = this.baseUrl + "/employees?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (statuses === null)
            throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        if (roles === null)
            throw new Error("The parameter 'roles' cannot be null.");
        else if (roles !== undefined)
            roles && roles.forEach(item => { url_ += "roles=" + encodeURIComponent("" + item) + "&"; });
        if (unitIds === null)
            throw new Error("The parameter 'unitIds' cannot be null.");
        else if (unitIds !== undefined)
            unitIds && unitIds.forEach(item => { url_ += "unitIds=" + encodeURIComponent("" + item) + "&"; });
        if (employeeIds === null)
            throw new Error("The parameter 'employeeIds' cannot be null.");
        else if (employeeIds !== undefined)
            employeeIds && employeeIds.forEach(item => { url_ += "employeeIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmployees(_response);
        });
    }

    protected processGetEmployees(response: Response): Promise<EmployeeListResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeListResultDto>(null as any);
    }

    /**
     * @param employeeId Employee id or constant `me`
     * @param lang (optional) 
     */
    getPublicProfile(employeeId: string, lang: string | undefined): Promise<EmployeeProfileResultDto> {
        let url_ = this.baseUrl + "/employees/{employeeId}/profile?";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPublicProfile(_response);
        });
    }

    protected processGetPublicProfile(response: Response): Promise<EmployeeProfileResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeProfileResultDto>(null as any);
    }

    /**
     * Capabilities=view-employment; Scopes=SELF
     * @param employeeId Employee id or constant `me`
     * @param order (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @param lang (optional) 
     * @param treeId (optional) 
     * @param roles (optional) 
     * @param unitIds (optional) 
     */
    getEmployeeTeam(employeeId: string, order: Order6 | undefined, offset: number | undefined, limit: number | undefined, lang: string | undefined, treeId: string | undefined, roles: string[] | undefined, unitIds: number[] | undefined): Promise<TeamMemberListResultDto> {
        let url_ = this.baseUrl + "/employees/{employeeId}/team/members?";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (treeId === null)
            throw new Error("The parameter 'treeId' cannot be null.");
        else if (treeId !== undefined)
            url_ += "treeId=" + encodeURIComponent("" + treeId) + "&";
        if (roles === null)
            throw new Error("The parameter 'roles' cannot be null.");
        else if (roles !== undefined)
            roles && roles.forEach(item => { url_ += "roles=" + encodeURIComponent("" + item) + "&"; });
        if (unitIds === null)
            throw new Error("The parameter 'unitIds' cannot be null.");
        else if (unitIds !== undefined)
            unitIds && unitIds.forEach(item => { url_ += "unitIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmployeeTeam(_response);
        });
    }

    protected processGetEmployeeTeam(response: Response): Promise<TeamMemberListResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamMemberListResultDto>(null as any);
    }

    searchEmployees(order: Order7 | undefined, limit: number | undefined, lang: string | undefined, search: string): Promise<EmployeeMetaListResultDto> {
        let url_ = this.baseUrl + "/employees/search?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (search === undefined || search === null)
            throw new Error("The parameter 'search' must be defined and cannot be null.");
        else
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearchEmployees(_response);
        });
    }

    protected processSearchEmployees(response: Response): Promise<EmployeeMetaListResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeMetaListResultDto>(null as any);
    }
}

export class PublicHolidayControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/people";
    }

    getPublicHolidays(legalEntities: number[] | undefined, countryCodes: string[] | undefined, years: number[] | undefined): Promise<PublicHolidayListResultDto> {
        let url_ = this.baseUrl + "/company/public-holidays?";
        if (legalEntities === null)
            throw new Error("The parameter 'legalEntities' cannot be null.");
        else if (legalEntities !== undefined)
            legalEntities && legalEntities.forEach(item => { url_ += "legalEntities=" + encodeURIComponent("" + item) + "&"; });
        if (countryCodes === null)
            throw new Error("The parameter 'countryCodes' cannot be null.");
        else if (countryCodes !== undefined)
            countryCodes && countryCodes.forEach(item => { url_ += "countryCodes=" + encodeURIComponent("" + item) + "&"; });
        if (years === null)
            throw new Error("The parameter 'years' cannot be null.");
        else if (years !== undefined)
            years && years.forEach(item => { url_ += "years=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPublicHolidays(_response);
        });
    }

    protected processGetPublicHolidays(response: Response): Promise<PublicHolidayListResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PublicHolidayListResultDto>(null as any);
    }
}

export class CollaborationControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/people";
    }

    getTasks(order: Order8 | undefined, offset: number | undefined, limit: number | undefined, lang: string | undefined, statuses: TaskStatusEnum[] | undefined, unitIds: number[] | undefined, completedByIds: number[] | undefined, pertainingToIds: number[] | undefined, assigneeIds: number[] | undefined, assignorIds: number[] | undefined): Promise<TaskListResultDto> {
        let url_ = this.baseUrl + "/tasks?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (statuses === null)
            throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        if (unitIds === null)
            throw new Error("The parameter 'unitIds' cannot be null.");
        else if (unitIds !== undefined)
            unitIds && unitIds.forEach(item => { url_ += "unitIds=" + encodeURIComponent("" + item) + "&"; });
        if (completedByIds === null)
            throw new Error("The parameter 'completedByIds' cannot be null.");
        else if (completedByIds !== undefined)
            completedByIds && completedByIds.forEach(item => { url_ += "completedByIds=" + encodeURIComponent("" + item) + "&"; });
        if (pertainingToIds === null)
            throw new Error("The parameter 'pertainingToIds' cannot be null.");
        else if (pertainingToIds !== undefined)
            pertainingToIds && pertainingToIds.forEach(item => { url_ += "pertainingToIds=" + encodeURIComponent("" + item) + "&"; });
        if (assigneeIds === null)
            throw new Error("The parameter 'assigneeIds' cannot be null.");
        else if (assigneeIds !== undefined)
            assigneeIds && assigneeIds.forEach(item => { url_ += "assigneeIds=" + encodeURIComponent("" + item) + "&"; });
        if (assignorIds === null)
            throw new Error("The parameter 'assignorIds' cannot be null.");
        else if (assignorIds !== undefined)
            assignorIds && assignorIds.forEach(item => { url_ += "assignorIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTasks(_response);
        });
    }

    protected processGetTasks(response: Response): Promise<TaskListResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskListResultDto>(null as any);
    }

    getTaskComments(taskId: number, order: Order9 | undefined, offset: number | undefined, limit: number | undefined, lang: string | undefined): Promise<TaskCommentListResultDto> {
        let url_ = this.baseUrl + "/tasks/{taskId}/comments?";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTaskComments(_response);
        });
    }

    protected processGetTaskComments(response: Response): Promise<TaskCommentListResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskCommentListResultDto>(null as any);
    }

    /**
     * @param employeeId Employee id or constant `me`
     * @param order (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @param lang (optional) 
     * @param statuses (optional) 
     */
    getEmployeeAssignedTasks(employeeId: string, order: Order10 | undefined, offset: number | undefined, limit: number | undefined, lang: string | undefined, statuses: TaskStatusEnum[] | undefined): Promise<TaskListResultDto2> {
        let url_ = this.baseUrl + "/employees/{employeeId}/tasks/assigned?";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (statuses === null)
            throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmployeeAssignedTasks(_response);
        });
    }

    protected processGetEmployeeAssignedTasks(response: Response): Promise<TaskListResultDto2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskListResultDto2>(null as any);
    }

    /**
     * Capabilities=view-task; Scopes=SELF
     * @param employeeId Employee id or constant `me`
     * @param order (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @param lang (optional) 
     * @param treeId (optional) 
     * @param roles (optional) 
     * @param statuses (optional) 
     * @param unitIds (optional) 
     */
    getTeamTasks(employeeId: string, order: Order11 | undefined, offset: number | undefined, limit: number | undefined, lang: string | undefined, treeId: string | undefined, roles: string[] | undefined, statuses: TaskStatusEnum[] | undefined, unitIds: number[] | undefined): Promise<TaskListResultDto3> {
        let url_ = this.baseUrl + "/employees/{employeeId}/team/tasks?";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (treeId === null)
            throw new Error("The parameter 'treeId' cannot be null.");
        else if (treeId !== undefined)
            url_ += "treeId=" + encodeURIComponent("" + treeId) + "&";
        if (roles === null)
            throw new Error("The parameter 'roles' cannot be null.");
        else if (roles !== undefined)
            roles && roles.forEach(item => { url_ += "roles=" + encodeURIComponent("" + item) + "&"; });
        if (statuses === null)
            throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        if (unitIds === null)
            throw new Error("The parameter 'unitIds' cannot be null.");
        else if (unitIds !== undefined)
            unitIds && unitIds.forEach(item => { url_ += "unitIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTeamTasks(_response);
        });
    }

    protected processGetTeamTasks(response: Response): Promise<TaskListResultDto3> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskListResultDto3>(null as any);
    }

    /**
     * Capabilities=view-worklist; Scopes=SELF
     * @param employeeId Employee id or constant `me`
     * @param order (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param lang (optional) 
     * @param statuses (optional) 
     * @param roles (optional) 
     */
    getMyWorklists(employeeId: string, order: Order12 | undefined, offset: number | undefined, limit: number | undefined, startDate: Date | undefined, endDate: Date | undefined, lang: string | undefined, statuses: TaskStatusEnum[] | undefined, roles: Roles[] | undefined): Promise<WorklistListResultDto> {
        let url_ = this.baseUrl + "/employees/{employeeId}/worklists/assigned?";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (statuses === null)
            throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        if (roles === null)
            throw new Error("The parameter 'roles' cannot be null.");
        else if (roles !== undefined)
            roles && roles.forEach(item => { url_ += "roles=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyWorklists(_response);
        });
    }

    protected processGetMyWorklists(response: Response): Promise<WorklistListResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorklistListResultDto>(null as any);
    }

    /**
     * Capabilities=edit-worklist; Scopes=SELF
     * @param employeeId Employee id or constant `me`
     */
    updateEmployeeTasks(employeeId: string, body: BulkUpdateEmployeeTasksStatusInputDto): Promise<void> {
        let url_ = this.baseUrl + "/employees/{employeeId}/worklists";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateEmployeeTasks(_response);
        });
    }

    protected processUpdateEmployeeTasks(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Capabilities=view-worklist; Scopes=BELOW
     * @param employeeId Employee id or constant `me`
     * @param order (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @param lang (optional) 
     * @param treeId (optional) 
     * @param statuses (optional) 
     * @param roles (optional) 
     */
    getTeamWorklists(employeeId: string, order: Order13 | undefined, offset: number | undefined, limit: number | undefined, lang: string | undefined, treeId: string | undefined, statuses: TaskStatusEnum[] | undefined, roles: Roles2[] | undefined): Promise<WorklistListResultDto2> {
        let url_ = this.baseUrl + "/employees/{employeeId}/team/worklists?";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (treeId === null)
            throw new Error("The parameter 'treeId' cannot be null.");
        else if (treeId !== undefined)
            url_ += "treeId=" + encodeURIComponent("" + treeId) + "&";
        if (statuses === null)
            throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        if (roles === null)
            throw new Error("The parameter 'roles' cannot be null.");
        else if (roles !== undefined)
            roles && roles.forEach(item => { url_ += "roles=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTeamWorklists(_response);
        });
    }

    protected processGetTeamWorklists(response: Response): Promise<WorklistListResultDto2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorklistListResultDto2>(null as any);
    }

    /**
     * Capabilities=edit-worklist; Scopes=BELOW
     * @param employeeId Employee id or constant `me`
     */
    updateTeamWorklists(employeeId: string, body: BulkUpdateWorklistTasksStatusInputDto): Promise<void> {
        let url_ = this.baseUrl + "/employees/{employeeId}/team/worklists";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTeamWorklists(_response);
        });
    }

    protected processUpdateTeamWorklists(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TrainingReadControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/people";
    }

    getTrainings(order: Order14 | undefined, offset: number | undefined, limit: number | undefined, startDate: Date | undefined, endDate: Date | undefined, lang: string | undefined, types: TrainingTypeGroupEnum[] | undefined, unitIds: number[] | undefined, employeeIds: number[] | undefined): Promise<TrainingListResultDto> {
        let url_ = this.baseUrl + "/trainings?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (types === null)
            throw new Error("The parameter 'types' cannot be null.");
        else if (types !== undefined)
            types && types.forEach(item => { url_ += "types=" + encodeURIComponent("" + item) + "&"; });
        if (unitIds === null)
            throw new Error("The parameter 'unitIds' cannot be null.");
        else if (unitIds !== undefined)
            unitIds && unitIds.forEach(item => { url_ += "unitIds=" + encodeURIComponent("" + item) + "&"; });
        if (employeeIds === null)
            throw new Error("The parameter 'employeeIds' cannot be null.");
        else if (employeeIds !== undefined)
            employeeIds && employeeIds.forEach(item => { url_ += "employeeIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTrainings(_response);
        });
    }

    protected processGetTrainings(response: Response): Promise<TrainingListResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrainingListResultDto>(null as any);
    }

    /**
     * @param employeeId Employee id or constant `me`
     * @param order (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param lang (optional) 
     * @param types (optional) 
     */
    getEmployeeTrainings(employeeId: string, order: Order15 | undefined, offset: number | undefined, limit: number | undefined, startDate: Date | undefined, endDate: Date | undefined, lang: string | undefined, types: TrainingTypeGroupEnum[] | undefined): Promise<TrainingListResultDto2> {
        let url_ = this.baseUrl + "/employees/{employeeId}/trainings?";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (types === null)
            throw new Error("The parameter 'types' cannot be null.");
        else if (types !== undefined)
            types && types.forEach(item => { url_ += "types=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmployeeTrainings(_response);
        });
    }

    protected processGetEmployeeTrainings(response: Response): Promise<TrainingListResultDto2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrainingListResultDto2>(null as any);
    }

    /**
     * Capabilities=view-development; Scopes=SELF
     * @param employeeId Employee id or constant `me`
     * @param order (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @param lang (optional) 
     * @param treeId (optional) 
     * @param roles (optional) 
     * @param unitIds (optional) 
     */
    getTeamTrainings(employeeId: string, order: Order16 | undefined, offset: number | undefined, limit: number | undefined, lang: string | undefined, treeId: string | undefined, roles: string[] | undefined, unitIds: number[] | undefined): Promise<TrainingListResultDto3> {
        let url_ = this.baseUrl + "/employees/{employeeId}/team/trainings?";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (treeId === null)
            throw new Error("The parameter 'treeId' cannot be null.");
        else if (treeId !== undefined)
            url_ += "treeId=" + encodeURIComponent("" + treeId) + "&";
        if (roles === null)
            throw new Error("The parameter 'roles' cannot be null.");
        else if (roles !== undefined)
            roles && roles.forEach(item => { url_ += "roles=" + encodeURIComponent("" + item) + "&"; });
        if (unitIds === null)
            throw new Error("The parameter 'unitIds' cannot be null.");
        else if (unitIds !== undefined)
            unitIds && unitIds.forEach(item => { url_ += "unitIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTeamTrainings(_response);
        });
    }

    protected processGetTeamTrainings(response: Response): Promise<TrainingListResultDto3> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrainingListResultDto3>(null as any);
    }
}

export class AnnouncementControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/people";
    }

    getAnnouncements(order: Order17 | undefined, offset: number | undefined, limit: number | undefined, lang: string | undefined): Promise<AnnouncementListResultDto> {
        let url_ = this.baseUrl + "/announcements?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAnnouncements(_response);
        });
    }

    protected processGetAnnouncements(response: Response): Promise<AnnouncementListResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnnouncementListResultDto>(null as any);
    }

    addAnnouncement(body: AnnouncementDataDto): Promise<Anonymous> {
        let url_ = this.baseUrl + "/announcements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddAnnouncement(_response);
        });
    }

    protected processAddAnnouncement(response: Response): Promise<Anonymous> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Anonymous>(null as any);
    }

    updateAnnouncement(id: number, body: AnnouncementDataDto): Promise<void> {
        let url_ = this.baseUrl + "/announcements/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateAnnouncement(_response);
        });
    }

    protected processUpdateAnnouncement(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 202) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    removeAnnouncement(id: number): Promise<void> {
        let url_ = this.baseUrl + "/announcements/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveAnnouncement(_response);
        });
    }

    protected processRemoveAnnouncement(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 202) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AnniversaryReadControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/people";
    }

    getAnniversaries(order: Order18 | undefined, startDate: Date | undefined, endDate: Date | undefined, lang: string | undefined, types: AnniversaryTypeEnum[] | undefined, unitIds: number[] | undefined, employeeIds: number[] | undefined): Promise<AnniversaryListResultDto> {
        let url_ = this.baseUrl + "/anniversaries?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (types === null)
            throw new Error("The parameter 'types' cannot be null.");
        else if (types !== undefined)
            types && types.forEach(item => { url_ += "types=" + encodeURIComponent("" + item) + "&"; });
        if (unitIds === null)
            throw new Error("The parameter 'unitIds' cannot be null.");
        else if (unitIds !== undefined)
            unitIds && unitIds.forEach(item => { url_ += "unitIds=" + encodeURIComponent("" + item) + "&"; });
        if (employeeIds === null)
            throw new Error("The parameter 'employeeIds' cannot be null.");
        else if (employeeIds !== undefined)
            employeeIds && employeeIds.forEach(item => { url_ += "employeeIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAnniversaries(_response);
        });
    }

    protected processGetAnniversaries(response: Response): Promise<AnniversaryListResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnniversaryListResultDto>(null as any);
    }

    /**
     * Capabilities=view-employment; Scopes=SELF
     * @param employeeId Employee id or constant `me`
     * @param order (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param lang (optional) 
     * @param treeId (optional) 
     * @param types (optional) 
     * @param roles (optional) 
     * @param unitIds (optional) 
     */
    getTeamAnniversaries(employeeId: string, order: Order19 | undefined, startDate: Date | undefined, endDate: Date | undefined, lang: string | undefined, treeId: string | undefined, types: AnniversaryTypeEnum[] | undefined, roles: string[] | undefined, unitIds: number[] | undefined): Promise<AnniversaryListResultDto2> {
        let url_ = this.baseUrl + "/employees/{employeeId}/team/anniversaries?";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (treeId === null)
            throw new Error("The parameter 'treeId' cannot be null.");
        else if (treeId !== undefined)
            url_ += "treeId=" + encodeURIComponent("" + treeId) + "&";
        if (types === null)
            throw new Error("The parameter 'types' cannot be null.");
        else if (types !== undefined)
            types && types.forEach(item => { url_ += "types=" + encodeURIComponent("" + item) + "&"; });
        if (roles === null)
            throw new Error("The parameter 'roles' cannot be null.");
        else if (roles !== undefined)
            roles && roles.forEach(item => { url_ += "roles=" + encodeURIComponent("" + item) + "&"; });
        if (unitIds === null)
            throw new Error("The parameter 'unitIds' cannot be null.");
        else if (unitIds !== undefined)
            unitIds && unitIds.forEach(item => { url_ += "unitIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTeamAnniversaries(_response);
        });
    }

    protected processGetTeamAnniversaries(response: Response): Promise<AnniversaryListResultDto2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnniversaryListResultDto2>(null as any);
    }
}

export class NotificationReadControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/people";
    }

    /**
     * @param order (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param lang (optional) 
     * @param topics (optional) Does support wildcard topics by using the `%` character(urlencoded!!)
     */
    getNotifications(order: Order20 | undefined, offset: number | undefined, limit: number | undefined, startDate: Date | undefined, endDate: Date | undefined, lang: string | undefined, topics: string[] | undefined): Promise<NotificationListResultDto> {
        let url_ = this.baseUrl + "/notifications?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (topics === null)
            throw new Error("The parameter 'topics' cannot be null.");
        else if (topics !== undefined)
            topics && topics.forEach(item => { url_ += "topics=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNotifications(_response);
        });
    }

    protected processGetNotifications(response: Response): Promise<NotificationListResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationListResultDto>(null as any);
    }
}

export class QuickLinkControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/people";
    }

    getQuickLinks(order: Order21 | undefined, offset: number | undefined, limit: number | undefined, lang: string | undefined, full: boolean | undefined, roles: string[] | undefined): Promise<QuickLinkListResultDto> {
        let url_ = this.baseUrl + "/quick-links?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (full === null)
            throw new Error("The parameter 'full' cannot be null.");
        else if (full !== undefined)
            url_ += "full=" + encodeURIComponent("" + full) + "&";
        if (roles === null)
            throw new Error("The parameter 'roles' cannot be null.");
        else if (roles !== undefined)
            roles && roles.forEach(item => { url_ += "roles=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuickLinks(_response);
        });
    }

    protected processGetQuickLinks(response: Response): Promise<QuickLinkListResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuickLinkListResultDto>(null as any);
    }

    addQuickLink(body: QuickLinkInputDto): Promise<Anonymous2> {
        let url_ = this.baseUrl + "/quick-links";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddQuickLink(_response);
        });
    }

    protected processAddQuickLink(response: Response): Promise<Anonymous2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Anonymous2>(null as any);
    }

    getEmployeeQuickLinks(order: Order22 | undefined, offset: number | undefined, limit: number | undefined, lang: string | undefined): Promise<QuickLinkListResultDto2> {
        let url_ = this.baseUrl + "/employees/me/quick-links?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmployeeQuickLinks(_response);
        });
    }

    protected processGetEmployeeQuickLinks(response: Response): Promise<QuickLinkListResultDto2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuickLinkListResultDto2>(null as any);
    }

    getQuickLink(id: string, full: boolean | undefined, lang: string | undefined): Promise<QuickLinkResultDto> {
        let url_ = this.baseUrl + "/quick-links/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (full === null)
            throw new Error("The parameter 'full' cannot be null.");
        else if (full !== undefined)
            url_ += "full=" + encodeURIComponent("" + full) + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuickLink(_response);
        });
    }

    protected processGetQuickLink(response: Response): Promise<QuickLinkResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuickLinkResultDto>(null as any);
    }

    updateQuickLink(id: string, body: QuickLinkInputDto): Promise<void> {
        let url_ = this.baseUrl + "/quick-links/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateQuickLink(_response);
        });
    }

    protected processUpdateQuickLink(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 202) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    removeQuickLink(id: string): Promise<void> {
        let url_ = this.baseUrl + "/quick-links/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveQuickLink(_response);
        });
    }

    protected processRemoveQuickLink(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 202) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    setQuickLinkTranslation(id: string, body: SetQuickLinkTranslationsInputDto): Promise<void> {
        let url_ = this.baseUrl + "/quick-links/{id}/translations";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetQuickLinkTranslation(_response);
        });
    }

    protected processSetQuickLinkTranslation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    bulkRemoveQuickLinks(body: BulkRemoveQuickLinksInputDto): Promise<void> {
        let url_ = this.baseUrl + "/quick-links/bulk-delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBulkRemoveQuickLinks(_response);
        });
    }

    protected processBulkRemoveQuickLinks(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    bulkUpdateOrder(body: BulkUpdateOrderInputDto): Promise<void> {
        let url_ = this.baseUrl + "/quick-links/order";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBulkUpdateOrder(_response);
        });
    }

    protected processBulkUpdateOrder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CompanyPostControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/people";
    }

    getCompanyPosts(order: Order23 | undefined, offset: number | undefined, limit: number | undefined, lang: string | undefined, statuses: CompanyPostStatusEnum[] | undefined): Promise<CompanyPostListResultDto> {
        let url_ = this.baseUrl + "/collab/posts?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (statuses === null)
            throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCompanyPosts(_response);
        });
    }

    protected processGetCompanyPosts(response: Response): Promise<CompanyPostListResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyPostListResultDto>(null as any);
    }
}

export class TimesheetControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/people";
    }

    /**
     * Capabilities=view-timesheet; Scopes=SELF
     * @param employeeId Employee id or constant `me`
     * @param order (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @param lang (optional) 
     * @param treeId (optional) 
     * @param roles (optional) 
     * @param unitIds (optional) 
     */
    getTeamTimesheet(employeeId: string, order: Order24 | undefined, offset: number | undefined, limit: number | undefined, lang: string | undefined, treeId: string | undefined, roles: string[] | undefined, unitIds: number[] | undefined): Promise<TimesheetShortListResultDto> {
        let url_ = this.baseUrl + "/employees/{employeeId}/team/timesheet?";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (treeId === null)
            throw new Error("The parameter 'treeId' cannot be null.");
        else if (treeId !== undefined)
            url_ += "treeId=" + encodeURIComponent("" + treeId) + "&";
        if (roles === null)
            throw new Error("The parameter 'roles' cannot be null.");
        else if (roles !== undefined)
            roles && roles.forEach(item => { url_ += "roles=" + encodeURIComponent("" + item) + "&"; });
        if (unitIds === null)
            throw new Error("The parameter 'unitIds' cannot be null.");
        else if (unitIds !== undefined)
            unitIds && unitIds.forEach(item => { url_ += "unitIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTeamTimesheet(_response);
        });
    }

    protected processGetTeamTimesheet(response: Response): Promise<TimesheetShortListResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimesheetShortListResultDto>(null as any);
    }
}

export class EvaluationControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/people";
    }

    getEvaluationSummaries(order: Order25 | undefined, offset: number | undefined, limit: number | undefined, lang: string | undefined): Promise<EvaluationSummaryListResultDto> {
        let url_ = this.baseUrl + "/appraisal/evaluations?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEvaluationSummaries(_response);
        });
    }

    protected processGetEvaluationSummaries(response: Response): Promise<EvaluationSummaryListResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EvaluationSummaryListResultDto>(null as any);
    }
}

export class PerformanceGoalControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/people";
    }

    /**
     * @param employeeId Employee id or constant `me`
     * @param lang (optional) 
     */
    getEmployeeCurrentPerformanceGoal(employeeId: string, lang: string | undefined): Promise<PerformanceGoalFullResultDto> {
        let url_ = this.baseUrl + "/employees/{employeeId}/performance/current?";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmployeeCurrentPerformanceGoal(_response);
        });
    }

    protected processGetEmployeeCurrentPerformanceGoal(response: Response): Promise<PerformanceGoalFullResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PerformanceGoalFullResultDto>(null as any);
    }

    /**
     * Capabilities=view-performance; Scopes=SELF
     * @param employeeId Employee id or constant `me`
     * @param order (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @param lang (optional) 
     * @param treeId (optional) 
     * @param roles (optional) 
     * @param unitIds (optional) 
     */
    getTeamPerformanceScores(employeeId: string, order: Order26 | undefined, offset: number | undefined, limit: number | undefined, lang: string | undefined, treeId: string | undefined, roles: string[] | undefined, unitIds: number[] | undefined): Promise<PerformanceGoalListResultDto> {
        let url_ = this.baseUrl + "/employees/{employeeId}/team/performance?";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (treeId === null)
            throw new Error("The parameter 'treeId' cannot be null.");
        else if (treeId !== undefined)
            url_ += "treeId=" + encodeURIComponent("" + treeId) + "&";
        if (roles === null)
            throw new Error("The parameter 'roles' cannot be null.");
        else if (roles !== undefined)
            roles && roles.forEach(item => { url_ += "roles=" + encodeURIComponent("" + item) + "&"; });
        if (unitIds === null)
            throw new Error("The parameter 'unitIds' cannot be null.");
        else if (unitIds !== undefined)
            unitIds && unitIds.forEach(item => { url_ += "unitIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTeamPerformanceScores(_response);
        });
    }

    protected processGetTeamPerformanceScores(response: Response): Promise<PerformanceGoalListResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PerformanceGoalListResultDto>(null as any);
    }
}

export class CompensationReadControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/people";
    }

    /**
     * @param employeeId Employee id or constant `me`
     */
    getCompensationsSummary(employeeId: string): Promise<CompensationsSummaryResultDto> {
        let url_ = this.baseUrl + "/employees/{employeeId}/compensations/summary";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCompensationsSummary(_response);
        });
    }

    protected processGetCompensationsSummary(response: Response): Promise<CompensationsSummaryResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompensationsSummaryResultDto>(null as any);
    }

    /**
     * Capabilities=view-employment; Scopes=SELF
     * @param employeeId Employee id or constant `me`
     * @param order (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param lang (optional) 
     * @param treeId (optional) 
     * @param roles (optional) 
     * @param unitIds (optional) 
     */
    getTeamCompensations(employeeId: string, order: Order27 | undefined, offset: number | undefined, limit: number | undefined, startDate: Date | undefined, endDate: Date | undefined, lang: string | undefined, treeId: string | undefined, roles: string[] | undefined, unitIds: number[] | undefined): Promise<CompensationListResultDto> {
        let url_ = this.baseUrl + "/employees/{employeeId}/team/compensations?";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (treeId === null)
            throw new Error("The parameter 'treeId' cannot be null.");
        else if (treeId !== undefined)
            url_ += "treeId=" + encodeURIComponent("" + treeId) + "&";
        if (roles === null)
            throw new Error("The parameter 'roles' cannot be null.");
        else if (roles !== undefined)
            roles && roles.forEach(item => { url_ += "roles=" + encodeURIComponent("" + item) + "&"; });
        if (unitIds === null)
            throw new Error("The parameter 'unitIds' cannot be null.");
        else if (unitIds !== undefined)
            unitIds && unitIds.forEach(item => { url_ += "unitIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTeamCompensations(_response);
        });
    }

    protected processGetTeamCompensations(response: Response): Promise<CompensationListResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompensationListResultDto>(null as any);
    }
}

export class DevelopmentPlanReadControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/people";
    }

    /**
     * @param employeeId Employee id or constant `me`
     * @param order (optional) 
     * @param lang (optional) 
     */
    getEmployeeCurrentDevelopmentPlan(employeeId: string, order: Order28 | undefined, lang: string | undefined): Promise<DevelopmentPlanResultDto> {
        let url_ = this.baseUrl + "/employees/{employeeId}/development/plans/current?";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmployeeCurrentDevelopmentPlan(_response);
        });
    }

    protected processGetEmployeeCurrentDevelopmentPlan(response: Response): Promise<DevelopmentPlanResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DevelopmentPlanResultDto>(null as any);
    }
}

export class EmploymentReadControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/people";
    }

    getEmployments(order: Order29 | undefined, offset: number | undefined, limit: number | undefined, lang: string | undefined, employmentIds: number[] | undefined): Promise<EmploymentListResultDto> {
        let url_ = this.baseUrl + "/employments?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (employmentIds === null)
            throw new Error("The parameter 'employmentIds' cannot be null.");
        else if (employmentIds !== undefined)
            employmentIds && employmentIds.forEach(item => { url_ += "employmentIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmployments(_response);
        });
    }

    protected processGetEmployments(response: Response): Promise<EmploymentListResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmploymentListResultDto>(null as any);
    }
}

export class RelationsReadControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/people";
    }

    getRelations(lang: string | undefined, employmentIds: number[] | undefined, employeeIds: number[] | undefined): Promise<RelationsDto> {
        let url_ = this.baseUrl + "/relations?";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (employmentIds === null)
            throw new Error("The parameter 'employmentIds' cannot be null.");
        else if (employmentIds !== undefined)
            employmentIds && employmentIds.forEach(item => { url_ += "employmentIds=" + encodeURIComponent("" + item) + "&"; });
        if (employeeIds === null)
            throw new Error("The parameter 'employeeIds' cannot be null.");
        else if (employeeIds !== undefined)
            employeeIds && employeeIds.forEach(item => { url_ += "employeeIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRelations(_response);
        });
    }

    protected processGetRelations(response: Response): Promise<RelationsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RelationsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RelationsDto>(null as any);
    }
}

export class EnumTranslationDto implements IEnumTranslationDto {
    group!: string;
    code!: string;
    language!: string | undefined;
    value!: string;

    constructor(data?: IEnumTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.group = _data["group"];
            this.code = _data["code"];
            this.language = _data["language"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): EnumTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnumTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["group"] = this.group;
        data["code"] = this.code;
        data["language"] = this.language;
        data["value"] = this.value;
        return data;
    }
}

export interface IEnumTranslationDto {
    group: string;
    code: string;
    language: string | undefined;
    value: string;
}

export enum AbsenceStatusEnum {
    DRAFT = "DRAFT",
    PROPOSED = "PROPOSED",
    APPROVED = "APPROVED",
    REJECTED = "REJECTED",
}

export class AbsenceStatusTranslationDto implements IAbsenceStatusTranslationDto {
    group!: string;
    code!: AbsenceStatusEnum;
    language!: string | undefined;
    value!: string;

    constructor(data?: IAbsenceStatusTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.group = _data["group"];
            this.code = _data["code"];
            this.language = _data["language"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): AbsenceStatusTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AbsenceStatusTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["group"] = this.group;
        data["code"] = this.code;
        data["language"] = this.language;
        data["value"] = this.value;
        return data;
    }
}

export interface IAbsenceStatusTranslationDto {
    group: string;
    code: AbsenceStatusEnum;
    language: string | undefined;
    value: string;
}

export enum AbsenceTypeEnum {
    SHORT = "SHORT",
    LONG = "LONG",
}

export class UnitDto implements IUnitDto {
    id!: number;
    name!: string;
    code!: string;
    type!: EnumTranslationDto;
    isActive!: boolean;

    constructor(data?: IUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.type = data.type && !(<any>data.type).toJSON ? new EnumTranslationDto(data.type) : <EnumTranslationDto>this.type;
        }
        if (!data) {
            this.type = new EnumTranslationDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.type = _data["type"] ? EnumTranslationDto.fromJS(_data["type"]) : new EnumTranslationDto();
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUnitDto {
    id: number;
    name: string;
    code: string;
    type: IEnumTranslationDto;
    isActive: boolean;
}

export class LegalEntityDto implements ILegalEntityDto {
    id!: number;
    name!: string;
    code!: string;
    isActive!: boolean;

    constructor(data?: ILegalEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): LegalEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new LegalEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ILegalEntityDto {
    id: number;
    name: string;
    code: string;
    isActive: boolean;
}

export class EmployeeShortDto implements IEmployeeShortDto {
    id!: number;
    unit!: UnitDto;
    firstName!: string;
    lastName!: string;
    userId!: number | undefined;
    username!: string | undefined;
    profilePic?: string | undefined;
    positionName!: EnumTranslationDto;
    legalEntity?: LegalEntityDto;

    constructor(data?: IEmployeeShortDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.unit = data.unit && !(<any>data.unit).toJSON ? new UnitDto(data.unit) : <UnitDto>this.unit;
            this.positionName = data.positionName && !(<any>data.positionName).toJSON ? new EnumTranslationDto(data.positionName) : <EnumTranslationDto>this.positionName;
            this.legalEntity = data.legalEntity && !(<any>data.legalEntity).toJSON ? new LegalEntityDto(data.legalEntity) : <LegalEntityDto>this.legalEntity;
        }
        if (!data) {
            this.unit = new UnitDto();
            this.positionName = new EnumTranslationDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.unit = _data["unit"] ? UnitDto.fromJS(_data["unit"]) : new UnitDto();
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.userId = _data["userId"];
            this.username = _data["username"];
            this.profilePic = _data["profilePic"];
            this.positionName = _data["positionName"] ? EnumTranslationDto.fromJS(_data["positionName"]) : new EnumTranslationDto();
            this.legalEntity = _data["legalEntity"] ? LegalEntityDto.fromJS(_data["legalEntity"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployeeShortDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeShortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["unit"] = this.unit ? this.unit.toJSON() : <any>undefined;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["userId"] = this.userId;
        data["username"] = this.username;
        data["profilePic"] = this.profilePic;
        data["positionName"] = this.positionName ? this.positionName.toJSON() : <any>undefined;
        data["legalEntity"] = this.legalEntity ? this.legalEntity.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmployeeShortDto {
    id: number;
    unit: IUnitDto;
    firstName: string;
    lastName: string;
    userId: number | undefined;
    username: string | undefined;
    profilePic?: string | undefined;
    positionName: IEnumTranslationDto;
    legalEntity?: ILegalEntityDto;
}

export class AbsenceDto implements IAbsenceDto {
    id!: number;
    uid!: string;
    reason!: EnumTranslationDto;
    status!: AbsenceStatusTranslationDto;
    type!: AbsenceTypeEnum;
    startDate!: Date;
    endDate?: Date | undefined;
    days?: number | undefined;
    employee!: EmployeeShortDto;

    constructor(data?: IAbsenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.reason = data.reason && !(<any>data.reason).toJSON ? new EnumTranslationDto(data.reason) : <EnumTranslationDto>this.reason;
            this.status = data.status && !(<any>data.status).toJSON ? new AbsenceStatusTranslationDto(data.status) : <AbsenceStatusTranslationDto>this.status;
            this.employee = data.employee && !(<any>data.employee).toJSON ? new EmployeeShortDto(data.employee) : <EmployeeShortDto>this.employee;
        }
        if (!data) {
            this.reason = new EnumTranslationDto();
            this.status = new AbsenceStatusTranslationDto();
            this.employee = new EmployeeShortDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.uid = _data["uid"];
            this.reason = _data["reason"] ? EnumTranslationDto.fromJS(_data["reason"]) : new EnumTranslationDto();
            this.status = _data["status"] ? AbsenceStatusTranslationDto.fromJS(_data["status"]) : new AbsenceStatusTranslationDto();
            this.type = _data["type"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.days = _data["days"];
            this.employee = _data["employee"] ? EmployeeShortDto.fromJS(_data["employee"]) : new EmployeeShortDto();
        }
    }

    static fromJS(data: any): AbsenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new AbsenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uid"] = this.uid;
        data["reason"] = this.reason ? this.reason.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>undefined;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : <any>undefined;
        data["days"] = this.days;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAbsenceDto {
    id: number;
    uid: string;
    reason: IEnumTranslationDto;
    status: IAbsenceStatusTranslationDto;
    type: AbsenceTypeEnum;
    startDate: Date;
    endDate?: Date | undefined;
    days?: number | undefined;
    employee: IEmployeeShortDto;
}

export enum GenderEnum {
    M = "M",
    F = "F",
}

export class CostCenterDto implements ICostCenterDto {
    id!: number;
    name!: string;
    code!: string;
    isActive!: boolean;

    constructor(data?: ICostCenterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CostCenterDto {
        data = typeof data === 'object' ? data : {};
        let result = new CostCenterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICostCenterDto {
    id: number;
    name: string;
    code: string;
    isActive: boolean;
}

export class PositionDto implements IPositionDto {
    id!: number;
    unit!: UnitDto;
    legalEntity!: LegalEntityDto;
    costCenter!: CostCenterDto;
    costCenterPercentage?: number;
    name!: EnumTranslationDto;
    info?: string;
    startDate!: Date;
    endDate?: Date;
    managerId?: number;
    higherManagerId?: number;
    jobTitle?: string;
    isPending!: boolean;

    constructor(data?: IPositionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.unit = data.unit && !(<any>data.unit).toJSON ? new UnitDto(data.unit) : <UnitDto>this.unit;
            this.legalEntity = data.legalEntity && !(<any>data.legalEntity).toJSON ? new LegalEntityDto(data.legalEntity) : <LegalEntityDto>this.legalEntity;
            this.costCenter = data.costCenter && !(<any>data.costCenter).toJSON ? new CostCenterDto(data.costCenter) : <CostCenterDto>this.costCenter;
            this.name = data.name && !(<any>data.name).toJSON ? new EnumTranslationDto(data.name) : <EnumTranslationDto>this.name;
        }
        if (!data) {
            this.unit = new UnitDto();
            this.legalEntity = new LegalEntityDto();
            this.costCenter = new CostCenterDto();
            this.name = new EnumTranslationDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.unit = _data["unit"] ? UnitDto.fromJS(_data["unit"]) : new UnitDto();
            this.legalEntity = _data["legalEntity"] ? LegalEntityDto.fromJS(_data["legalEntity"]) : new LegalEntityDto();
            this.costCenter = _data["costCenter"] ? CostCenterDto.fromJS(_data["costCenter"]) : new CostCenterDto();
            this.costCenterPercentage = _data["costCenterPercentage"];
            this.name = _data["name"] ? EnumTranslationDto.fromJS(_data["name"]) : new EnumTranslationDto();
            this.info = _data["info"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.managerId = _data["managerId"];
            this.higherManagerId = _data["higherManagerId"];
            this.jobTitle = _data["jobTitle"];
            this.isPending = _data["isPending"];
        }
    }

    static fromJS(data: any): PositionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PositionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["unit"] = this.unit ? this.unit.toJSON() : <any>undefined;
        data["legalEntity"] = this.legalEntity ? this.legalEntity.toJSON() : <any>undefined;
        data["costCenter"] = this.costCenter ? this.costCenter.toJSON() : <any>undefined;
        data["costCenterPercentage"] = this.costCenterPercentage;
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        data["info"] = this.info;
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>undefined;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : <any>undefined;
        data["managerId"] = this.managerId;
        data["higherManagerId"] = this.higherManagerId;
        data["jobTitle"] = this.jobTitle;
        data["isPending"] = this.isPending;
        return data;
    }
}

export interface IPositionDto {
    id: number;
    unit: IUnitDto;
    legalEntity: ILegalEntityDto;
    costCenter: ICostCenterDto;
    costCenterPercentage?: number;
    name: IEnumTranslationDto;
    info?: string;
    startDate: Date;
    endDate?: Date;
    managerId?: number;
    higherManagerId?: number;
    jobTitle?: string;
    isPending: boolean;
}

export enum EmployeeStatusEnum {
    PENDING = "PENDING",
    NEW = "NEW",
    ACTIVE = "ACTIVE",
    ENDED = "ENDED",
    PASSIVE = "PASSIVE",
    ARCHIVED = "ARCHIVED",
    DELETED = "DELETED",
}

export class EmployeeStatusTranslationDto implements IEmployeeStatusTranslationDto {
    group!: string;
    code!: EmployeeStatusEnum;
    language!: string | undefined;
    value!: string;

    constructor(data?: IEmployeeStatusTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.group = _data["group"];
            this.code = _data["code"];
            this.language = _data["language"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): EmployeeStatusTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeStatusTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["group"] = this.group;
        data["code"] = this.code;
        data["language"] = this.language;
        data["value"] = this.value;
        return data;
    }
}

export interface IEmployeeStatusTranslationDto {
    group: string;
    code: EmployeeStatusEnum;
    language: string | undefined;
    value: string;
}

export class EmployeeDto implements IEmployeeDto {
    id!: number;
    employeeNumber!: string;
    userId!: number | undefined;
    username!: string | undefined;
    firstName!: string;
    lastName!: string;
    givenNames!: string;
    gender!: GenderEnum;
    birthDate!: Date;
    profilePic!: string;
    position?: PositionDto;
    nationality!: EnumTranslationDto;
    status!: EmployeeStatusTranslationDto;

    constructor(data?: IEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.position = data.position && !(<any>data.position).toJSON ? new PositionDto(data.position) : <PositionDto>this.position;
            this.nationality = data.nationality && !(<any>data.nationality).toJSON ? new EnumTranslationDto(data.nationality) : <EnumTranslationDto>this.nationality;
            this.status = data.status && !(<any>data.status).toJSON ? new EmployeeStatusTranslationDto(data.status) : <EmployeeStatusTranslationDto>this.status;
        }
        if (!data) {
            this.nationality = new EnumTranslationDto();
            this.status = new EmployeeStatusTranslationDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeNumber = _data["employeeNumber"];
            this.userId = _data["userId"];
            this.username = _data["username"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.givenNames = _data["givenNames"];
            this.gender = _data["gender"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.profilePic = _data["profilePic"];
            this.position = _data["position"] ? PositionDto.fromJS(_data["position"]) : <any>undefined;
            this.nationality = _data["nationality"] ? EnumTranslationDto.fromJS(_data["nationality"]) : new EnumTranslationDto();
            this.status = _data["status"] ? EmployeeStatusTranslationDto.fromJS(_data["status"]) : new EmployeeStatusTranslationDto();
        }
    }

    static fromJS(data: any): EmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeNumber"] = this.employeeNumber;
        data["userId"] = this.userId;
        data["username"] = this.username;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["givenNames"] = this.givenNames;
        data["gender"] = this.gender;
        data["birthDate"] = this.birthDate ? formatDate(this.birthDate) : <any>undefined;
        data["profilePic"] = this.profilePic;
        data["position"] = this.position ? this.position.toJSON() : <any>undefined;
        data["nationality"] = this.nationality ? this.nationality.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmployeeDto {
    id: number;
    employeeNumber: string;
    userId: number | undefined;
    username: string | undefined;
    firstName: string;
    lastName: string;
    givenNames: string;
    gender: GenderEnum;
    birthDate: Date;
    profilePic: string;
    position?: IPositionDto;
    nationality: IEnumTranslationDto;
    status: IEmployeeStatusTranslationDto;
}

export class AddressDto implements IAddressDto {
    address1!: string;
    address2?: string | undefined;
    poBox?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    region?: string | undefined;
    country?: EnumTranslationDto | undefined;

    constructor(data?: IAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.country = data.country && !(<any>data.country).toJSON ? new EnumTranslationDto(data.country) : <EnumTranslationDto>this.country;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.poBox = _data["poBox"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.region = _data["region"];
            this.country = _data["country"] ? EnumTranslationDto.fromJS(_data["country"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["poBox"] = this.poBox;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["region"] = this.region;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAddressDto {
    address1: string;
    address2?: string | undefined;
    poBox?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    region?: string | undefined;
    country?: IEnumTranslationDto | undefined;
}

export class PersonContactDto implements IPersonContactDto {
    email?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    address?: AddressDto | undefined;

    constructor(data?: IPersonContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.address = data.address && !(<any>data.address).toJSON ? new AddressDto(data.address) : <AddressDto>this.address;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.mobile = _data["mobile"];
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PersonContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["mobile"] = this.mobile;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPersonContactDto {
    email?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    address?: IAddressDto | undefined;
}

export class EmergencyContactDto implements IEmergencyContactDto {
    name!: string;
    email?: string | undefined;
    phone?: string | undefined;

    constructor(data?: IEmergencyContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): EmergencyContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmergencyContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data;
    }
}

export interface IEmergencyContactDto {
    name: string;
    email?: string | undefined;
    phone?: string | undefined;
}

export class OfficeDto implements IOfficeDto {
    id!: number;
    name!: string;
    isActive!: boolean;
    code?: string | undefined;

    constructor(data?: IOfficeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): OfficeDto {
        data = typeof data === 'object' ? data : {};
        let result = new OfficeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["code"] = this.code;
        return data;
    }
}

export interface IOfficeDto {
    id: number;
    name: string;
    isActive: boolean;
    code?: string | undefined;
}

export class OfficeContactDto implements IOfficeContactDto {
    office!: OfficeDto;
    floor?: string | undefined;
    room?: string | undefined;
    address?: AddressDto | undefined;

    constructor(data?: IOfficeContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.office = data.office && !(<any>data.office).toJSON ? new OfficeDto(data.office) : <OfficeDto>this.office;
            this.address = data.address && !(<any>data.address).toJSON ? new AddressDto(data.address) : <AddressDto>this.address;
        }
        if (!data) {
            this.office = new OfficeDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.office = _data["office"] ? OfficeDto.fromJS(_data["office"]) : new OfficeDto();
            this.floor = _data["floor"];
            this.room = _data["room"];
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OfficeContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new OfficeContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["office"] = this.office ? this.office.toJSON() : <any>undefined;
        data["floor"] = this.floor;
        data["room"] = this.room;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOfficeContactDto {
    office: IOfficeDto;
    floor?: string | undefined;
    room?: string | undefined;
    address?: IAddressDto | undefined;
}

export class ContactDto implements IContactDto {
    home?: PersonContactDto;
    work?: PersonContactDto;
    other?: PersonContactDto;
    emergency?: EmergencyContactDto;
    office?: OfficeContactDto;

    constructor(data?: IContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.home = data.home && !(<any>data.home).toJSON ? new PersonContactDto(data.home) : <PersonContactDto>this.home;
            this.work = data.work && !(<any>data.work).toJSON ? new PersonContactDto(data.work) : <PersonContactDto>this.work;
            this.other = data.other && !(<any>data.other).toJSON ? new PersonContactDto(data.other) : <PersonContactDto>this.other;
            this.emergency = data.emergency && !(<any>data.emergency).toJSON ? new EmergencyContactDto(data.emergency) : <EmergencyContactDto>this.emergency;
            this.office = data.office && !(<any>data.office).toJSON ? new OfficeContactDto(data.office) : <OfficeContactDto>this.office;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.home = _data["home"] ? PersonContactDto.fromJS(_data["home"]) : <any>undefined;
            this.work = _data["work"] ? PersonContactDto.fromJS(_data["work"]) : <any>undefined;
            this.other = _data["other"] ? PersonContactDto.fromJS(_data["other"]) : <any>undefined;
            this.emergency = _data["emergency"] ? EmergencyContactDto.fromJS(_data["emergency"]) : <any>undefined;
            this.office = _data["office"] ? OfficeContactDto.fromJS(_data["office"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["home"] = this.home ? this.home.toJSON() : <any>undefined;
        data["work"] = this.work ? this.work.toJSON() : <any>undefined;
        data["other"] = this.other ? this.other.toJSON() : <any>undefined;
        data["emergency"] = this.emergency ? this.emergency.toJSON() : <any>undefined;
        data["office"] = this.office ? this.office.toJSON() : <any>undefined;
        return data;
    }
}

export interface IContactDto {
    home?: IPersonContactDto;
    work?: IPersonContactDto;
    other?: IPersonContactDto;
    emergency?: IEmergencyContactDto;
    office?: IOfficeContactDto;
}

export class EmployeeProfileDto implements IEmployeeProfileDto {
    id!: number;
    employeeNumber!: string;
    userId!: number | undefined;
    username!: string | undefined;
    firstName!: string;
    lastName!: string;
    givenNames!: string;
    profilePic!: string;
    unit!: UnitDto;
    legalEntity!: LegalEntityDto;
    costCenter!: CostCenterDto;
    positionName!: EnumTranslationDto;
    jobTitle!: string | undefined;
    contact!: ContactDto;
    manager?: EmployeeShortDto;

    constructor(data?: IEmployeeProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.unit = data.unit && !(<any>data.unit).toJSON ? new UnitDto(data.unit) : <UnitDto>this.unit;
            this.legalEntity = data.legalEntity && !(<any>data.legalEntity).toJSON ? new LegalEntityDto(data.legalEntity) : <LegalEntityDto>this.legalEntity;
            this.costCenter = data.costCenter && !(<any>data.costCenter).toJSON ? new CostCenterDto(data.costCenter) : <CostCenterDto>this.costCenter;
            this.positionName = data.positionName && !(<any>data.positionName).toJSON ? new EnumTranslationDto(data.positionName) : <EnumTranslationDto>this.positionName;
            this.contact = data.contact && !(<any>data.contact).toJSON ? new ContactDto(data.contact) : <ContactDto>this.contact;
            this.manager = data.manager && !(<any>data.manager).toJSON ? new EmployeeShortDto(data.manager) : <EmployeeShortDto>this.manager;
        }
        if (!data) {
            this.unit = new UnitDto();
            this.legalEntity = new LegalEntityDto();
            this.costCenter = new CostCenterDto();
            this.positionName = new EnumTranslationDto();
            this.contact = new ContactDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeNumber = _data["employeeNumber"];
            this.userId = _data["userId"];
            this.username = _data["username"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.givenNames = _data["givenNames"];
            this.profilePic = _data["profilePic"];
            this.unit = _data["unit"] ? UnitDto.fromJS(_data["unit"]) : new UnitDto();
            this.legalEntity = _data["legalEntity"] ? LegalEntityDto.fromJS(_data["legalEntity"]) : new LegalEntityDto();
            this.costCenter = _data["costCenter"] ? CostCenterDto.fromJS(_data["costCenter"]) : new CostCenterDto();
            this.positionName = _data["positionName"] ? EnumTranslationDto.fromJS(_data["positionName"]) : new EnumTranslationDto();
            this.jobTitle = _data["jobTitle"];
            this.contact = _data["contact"] ? ContactDto.fromJS(_data["contact"]) : new ContactDto();
            this.manager = _data["manager"] ? EmployeeShortDto.fromJS(_data["manager"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployeeProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeNumber"] = this.employeeNumber;
        data["userId"] = this.userId;
        data["username"] = this.username;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["givenNames"] = this.givenNames;
        data["profilePic"] = this.profilePic;
        data["unit"] = this.unit ? this.unit.toJSON() : <any>undefined;
        data["legalEntity"] = this.legalEntity ? this.legalEntity.toJSON() : <any>undefined;
        data["costCenter"] = this.costCenter ? this.costCenter.toJSON() : <any>undefined;
        data["positionName"] = this.positionName ? this.positionName.toJSON() : <any>undefined;
        data["jobTitle"] = this.jobTitle;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["manager"] = this.manager ? this.manager.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmployeeProfileDto {
    id: number;
    employeeNumber: string;
    userId: number | undefined;
    username: string | undefined;
    firstName: string;
    lastName: string;
    givenNames: string;
    profilePic: string;
    unit: IUnitDto;
    legalEntity: ILegalEntityDto;
    costCenter: ICostCenterDto;
    positionName: IEnumTranslationDto;
    jobTitle: string | undefined;
    contact: IContactDto;
    manager?: IEmployeeShortDto;
}

export class TeamMemberDto implements ITeamMemberDto {
    employeeId!: number;
    userId!: number | undefined;
    username!: string | undefined;
    unit!: UnitDto;
    legalEntity?: LegalEntityDto;
    firstName!: string;
    lastName!: string;
    profilePic?: string | undefined;
    positionName!: EnumTranslationDto;
    email!: string;
    phone?: string | undefined;
    mobile?: string | undefined;

    constructor(data?: ITeamMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.unit = data.unit && !(<any>data.unit).toJSON ? new UnitDto(data.unit) : <UnitDto>this.unit;
            this.legalEntity = data.legalEntity && !(<any>data.legalEntity).toJSON ? new LegalEntityDto(data.legalEntity) : <LegalEntityDto>this.legalEntity;
            this.positionName = data.positionName && !(<any>data.positionName).toJSON ? new EnumTranslationDto(data.positionName) : <EnumTranslationDto>this.positionName;
        }
        if (!data) {
            this.unit = new UnitDto();
            this.positionName = new EnumTranslationDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.userId = _data["userId"];
            this.username = _data["username"];
            this.unit = _data["unit"] ? UnitDto.fromJS(_data["unit"]) : new UnitDto();
            this.legalEntity = _data["legalEntity"] ? LegalEntityDto.fromJS(_data["legalEntity"]) : <any>undefined;
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.profilePic = _data["profilePic"];
            this.positionName = _data["positionName"] ? EnumTranslationDto.fromJS(_data["positionName"]) : new EnumTranslationDto();
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.mobile = _data["mobile"];
        }
    }

    static fromJS(data: any): TeamMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["userId"] = this.userId;
        data["username"] = this.username;
        data["unit"] = this.unit ? this.unit.toJSON() : <any>undefined;
        data["legalEntity"] = this.legalEntity ? this.legalEntity.toJSON() : <any>undefined;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["profilePic"] = this.profilePic;
        data["positionName"] = this.positionName ? this.positionName.toJSON() : <any>undefined;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["mobile"] = this.mobile;
        return data;
    }
}

export interface ITeamMemberDto {
    employeeId: number;
    userId: number | undefined;
    username: string | undefined;
    unit: IUnitDto;
    legalEntity?: ILegalEntityDto;
    firstName: string;
    lastName: string;
    profilePic?: string | undefined;
    positionName: IEnumTranslationDto;
    email: string;
    phone?: string | undefined;
    mobile?: string | undefined;
}

export class EmployeeMetaDto implements IEmployeeMetaDto {
    id!: number;
    employeeNumber!: string;
    firstName!: string;
    lastName!: string;
    profilePic?: string | undefined;
    positionName!: string;

    constructor(data?: IEmployeeMetaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeNumber = _data["employeeNumber"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.profilePic = _data["profilePic"];
            this.positionName = _data["positionName"];
        }
    }

    static fromJS(data: any): EmployeeMetaDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeMetaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeNumber"] = this.employeeNumber;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["profilePic"] = this.profilePic;
        data["positionName"] = this.positionName;
        return data;
    }
}

export interface IEmployeeMetaDto {
    id: number;
    employeeNumber: string;
    firstName: string;
    lastName: string;
    profilePic?: string | undefined;
    positionName: string;
}

export class PublicHolidayDto implements IPublicHolidayDto {
    name!: string;
    year!: number;
    date!: Date;
    country?: EnumTranslationDto | undefined;
    legalEntityId!: number;

    constructor(data?: IPublicHolidayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.country = data.country && !(<any>data.country).toJSON ? new EnumTranslationDto(data.country) : <EnumTranslationDto>this.country;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.year = _data["year"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.country = _data["country"] ? EnumTranslationDto.fromJS(_data["country"]) : <any>undefined;
            this.legalEntityId = _data["legalEntityId"];
        }
    }

    static fromJS(data: any): PublicHolidayDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublicHolidayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["year"] = this.year;
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["legalEntityId"] = this.legalEntityId;
        return data;
    }
}

export interface IPublicHolidayDto {
    name: string;
    year: number;
    date: Date;
    country?: IEnumTranslationDto | undefined;
    legalEntityId: number;
}

export enum TaskStatusEnum {
    NEW = "NEW",
    IN_PROGRESS = "IN_PROGRESS",
    COMPLETED = "COMPLETED",
    SKIPPED = "SKIPPED",
    DELETED = "DELETED",
}

export class TaskStatusTranslationDto implements ITaskStatusTranslationDto {
    group!: string;
    code!: TaskStatusEnum;
    language!: string | undefined;
    value!: string;

    constructor(data?: ITaskStatusTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.group = _data["group"];
            this.code = _data["code"];
            this.language = _data["language"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): TaskStatusTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskStatusTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["group"] = this.group;
        data["code"] = this.code;
        data["language"] = this.language;
        data["value"] = this.value;
        return data;
    }
}

export interface ITaskStatusTranslationDto {
    group: string;
    code: TaskStatusEnum;
    language: string | undefined;
    value: string;
}

export class TaskDto implements ITaskDto {
    id!: number;
    title!: string;
    description?: string;
    startDate!: Date;
    dueDate?: Date | undefined;
    completedDate?: Date | undefined;
    assignor!: EmployeeShortDto;
    assignee?: EmployeeShortDto | undefined;
    pertainingTo?: EmployeeShortDto | undefined;
    completedBy?: EmployeeShortDto | undefined;
    type!: EnumTranslationDto;
    status!: TaskStatusTranslationDto;
    createdAt!: Date;
    updatedAt!: Date;
    updatedBy!: EmployeeShortDto | undefined;
    templateFk!: number | undefined;
    worklistUid!: string | undefined;

    constructor(data?: ITaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.assignor = data.assignor && !(<any>data.assignor).toJSON ? new EmployeeShortDto(data.assignor) : <EmployeeShortDto>this.assignor;
            this.assignee = data.assignee && !(<any>data.assignee).toJSON ? new EmployeeShortDto(data.assignee) : <EmployeeShortDto>this.assignee;
            this.pertainingTo = data.pertainingTo && !(<any>data.pertainingTo).toJSON ? new EmployeeShortDto(data.pertainingTo) : <EmployeeShortDto>this.pertainingTo;
            this.completedBy = data.completedBy && !(<any>data.completedBy).toJSON ? new EmployeeShortDto(data.completedBy) : <EmployeeShortDto>this.completedBy;
            this.type = data.type && !(<any>data.type).toJSON ? new EnumTranslationDto(data.type) : <EnumTranslationDto>this.type;
            this.status = data.status && !(<any>data.status).toJSON ? new TaskStatusTranslationDto(data.status) : <TaskStatusTranslationDto>this.status;
            this.updatedBy = data.updatedBy && !(<any>data.updatedBy).toJSON ? new EmployeeShortDto(data.updatedBy) : <EmployeeShortDto>this.updatedBy;
        }
        if (!data) {
            this.assignor = new EmployeeShortDto();
            this.type = new EnumTranslationDto();
            this.status = new TaskStatusTranslationDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : <any>undefined;
            this.assignor = _data["assignor"] ? EmployeeShortDto.fromJS(_data["assignor"]) : new EmployeeShortDto();
            this.assignee = _data["assignee"] ? EmployeeShortDto.fromJS(_data["assignee"]) : <any>undefined;
            this.pertainingTo = _data["pertainingTo"] ? EmployeeShortDto.fromJS(_data["pertainingTo"]) : <any>undefined;
            this.completedBy = _data["completedBy"] ? EmployeeShortDto.fromJS(_data["completedBy"]) : <any>undefined;
            this.type = _data["type"] ? EnumTranslationDto.fromJS(_data["type"]) : new EnumTranslationDto();
            this.status = _data["status"] ? TaskStatusTranslationDto.fromJS(_data["status"]) : new TaskStatusTranslationDto();
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"] ? EmployeeShortDto.fromJS(_data["updatedBy"]) : <any>undefined;
            this.templateFk = _data["templateFk"];
            this.worklistUid = _data["worklistUid"];
        }
    }

    static fromJS(data: any): TaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>undefined;
        data["dueDate"] = this.dueDate ? formatDate(this.dueDate) : <any>undefined;
        data["completedDate"] = this.completedDate ? formatDate(this.completedDate) : <any>undefined;
        data["assignor"] = this.assignor ? this.assignor.toJSON() : <any>undefined;
        data["assignee"] = this.assignee ? this.assignee.toJSON() : <any>undefined;
        data["pertainingTo"] = this.pertainingTo ? this.pertainingTo.toJSON() : <any>undefined;
        data["completedBy"] = this.completedBy ? this.completedBy.toJSON() : <any>undefined;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy ? this.updatedBy.toJSON() : <any>undefined;
        data["templateFk"] = this.templateFk;
        data["worklistUid"] = this.worklistUid;
        return data;
    }
}

export interface ITaskDto {
    id: number;
    title: string;
    description?: string;
    startDate: Date;
    dueDate?: Date | undefined;
    completedDate?: Date | undefined;
    assignor: IEmployeeShortDto;
    assignee?: IEmployeeShortDto | undefined;
    pertainingTo?: IEmployeeShortDto | undefined;
    completedBy?: IEmployeeShortDto | undefined;
    type: IEnumTranslationDto;
    status: ITaskStatusTranslationDto;
    createdAt: Date;
    updatedAt: Date;
    updatedBy: IEmployeeShortDto | undefined;
    templateFk: number | undefined;
    worklistUid: string | undefined;
}

export class TaskCommentDto implements ITaskCommentDto {
    id!: number;
    comment!: string;
    createdAt!: Date;
    createdBy!: EmployeeShortDto;
    updatedAt!: Date;
    updatedBy!: EmployeeShortDto;

    constructor(data?: ITaskCommentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.createdBy = data.createdBy && !(<any>data.createdBy).toJSON ? new EmployeeShortDto(data.createdBy) : <EmployeeShortDto>this.createdBy;
            this.updatedBy = data.updatedBy && !(<any>data.updatedBy).toJSON ? new EmployeeShortDto(data.updatedBy) : <EmployeeShortDto>this.updatedBy;
        }
        if (!data) {
            this.createdBy = new EmployeeShortDto();
            this.updatedBy = new EmployeeShortDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.comment = _data["comment"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"] ? EmployeeShortDto.fromJS(_data["createdBy"]) : new EmployeeShortDto();
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"] ? EmployeeShortDto.fromJS(_data["updatedBy"]) : new EmployeeShortDto();
        }
    }

    static fromJS(data: any): TaskCommentDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskCommentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["comment"] = this.comment;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy ? this.updatedBy.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITaskCommentDto {
    id: number;
    comment: string;
    createdAt: Date;
    createdBy: IEmployeeShortDto;
    updatedAt: Date;
    updatedBy: IEmployeeShortDto;
}

export class WorklistEmployeeDetailsDto implements IWorklistEmployeeDetailsDto {
    employeeId!: number;
    userId!: number | undefined;
    username!: string | undefined;
    firstName!: string;
    lastName!: string;
    profilePic?: string | undefined;

    constructor(data?: IWorklistEmployeeDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.userId = _data["userId"];
            this.username = _data["username"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.profilePic = _data["profilePic"];
        }
    }

    static fromJS(data: any): WorklistEmployeeDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorklistEmployeeDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["userId"] = this.userId;
        data["username"] = this.username;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["profilePic"] = this.profilePic;
        return data;
    }
}

export interface IWorklistEmployeeDetailsDto {
    employeeId: number;
    userId: number | undefined;
    username: string | undefined;
    firstName: string;
    lastName: string;
    profilePic?: string | undefined;
}

export class WorklistTemplateDto implements IWorklistTemplateDto {
    id!: number;
    title!: string;
    description?: string;
    createdAt!: Date;
    createdBy!: number;
    updatedAt!: Date;
    updatedBy!: number;
    type!: EnumTranslationDto;
    defaultLanguage!: string;
    status!: WorklistTemplateDtoStatus;

    constructor(data?: IWorklistTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.type = data.type && !(<any>data.type).toJSON ? new EnumTranslationDto(data.type) : <EnumTranslationDto>this.type;
        }
        if (!data) {
            this.type = new EnumTranslationDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.type = _data["type"] ? EnumTranslationDto.fromJS(_data["type"]) : new EnumTranslationDto();
            this.defaultLanguage = _data["defaultLanguage"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): WorklistTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorklistTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["defaultLanguage"] = this.defaultLanguage;
        data["status"] = this.status;
        return data;
    }
}

export interface IWorklistTemplateDto {
    id: number;
    title: string;
    description?: string;
    createdAt: Date;
    createdBy: number;
    updatedAt: Date;
    updatedBy: number;
    type: IEnumTranslationDto;
    defaultLanguage: string;
    status: WorklistTemplateDtoStatus;
}

export class WorklistTaskDto implements IWorklistTaskDto {
    id!: number;
    title!: string;
    description?: string;
    startDate!: Date;
    dueDate?: Date | undefined;
    completedDate?: Date | undefined;
    type!: EnumTranslationDto;
    status!: TaskStatusTranslationDto;
    createdAt!: Date;
    updatedAt!: Date;
    templateFk!: number | undefined;
    worklistUid!: string | undefined;
    assignee?: WorklistEmployeeDetailsDto;

    constructor(data?: IWorklistTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.type = data.type && !(<any>data.type).toJSON ? new EnumTranslationDto(data.type) : <EnumTranslationDto>this.type;
            this.status = data.status && !(<any>data.status).toJSON ? new TaskStatusTranslationDto(data.status) : <TaskStatusTranslationDto>this.status;
            this.assignee = data.assignee && !(<any>data.assignee).toJSON ? new WorklistEmployeeDetailsDto(data.assignee) : <WorklistEmployeeDetailsDto>this.assignee;
        }
        if (!data) {
            this.type = new EnumTranslationDto();
            this.status = new TaskStatusTranslationDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : <any>undefined;
            this.type = _data["type"] ? EnumTranslationDto.fromJS(_data["type"]) : new EnumTranslationDto();
            this.status = _data["status"] ? TaskStatusTranslationDto.fromJS(_data["status"]) : new TaskStatusTranslationDto();
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.templateFk = _data["templateFk"];
            this.worklistUid = _data["worklistUid"];
            this.assignee = _data["assignee"] ? WorklistEmployeeDetailsDto.fromJS(_data["assignee"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WorklistTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorklistTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>undefined;
        data["dueDate"] = this.dueDate ? formatDate(this.dueDate) : <any>undefined;
        data["completedDate"] = this.completedDate ? formatDate(this.completedDate) : <any>undefined;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["templateFk"] = this.templateFk;
        data["worklistUid"] = this.worklistUid;
        data["assignee"] = this.assignee ? this.assignee.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWorklistTaskDto {
    id: number;
    title: string;
    description?: string;
    startDate: Date;
    dueDate?: Date | undefined;
    completedDate?: Date | undefined;
    type: IEnumTranslationDto;
    status: ITaskStatusTranslationDto;
    createdAt: Date;
    updatedAt: Date;
    templateFk: number | undefined;
    worklistUid: string | undefined;
    assignee?: IWorklistEmployeeDetailsDto;
}

export class WorklistDto implements IWorklistDto {
    id!: string;
    pertainingTo?: WorklistEmployeeDetailsDto | undefined;
    template!: WorklistTemplateDto;
    tasks!: WorklistTaskDto[];
    dueDate?: Date | undefined;
    status!: WorklistDtoStatus;

    constructor(data?: IWorklistDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.pertainingTo = data.pertainingTo && !(<any>data.pertainingTo).toJSON ? new WorklistEmployeeDetailsDto(data.pertainingTo) : <WorklistEmployeeDetailsDto>this.pertainingTo;
            this.template = data.template && !(<any>data.template).toJSON ? new WorklistTemplateDto(data.template) : <WorklistTemplateDto>this.template;
            if (data.tasks) {
                this.tasks = [];
                for (let i = 0; i < data.tasks.length; i++) {
                    let item = data.tasks[i];
                    this.tasks[i] = item && !(<any>item).toJSON ? new WorklistTaskDto(item) : <WorklistTaskDto>item;
                }
            }
        }
        if (!data) {
            this.template = new WorklistTemplateDto();
            this.tasks = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pertainingTo = _data["pertainingTo"] ? WorklistEmployeeDetailsDto.fromJS(_data["pertainingTo"]) : <any>undefined;
            this.template = _data["template"] ? WorklistTemplateDto.fromJS(_data["template"]) : new WorklistTemplateDto();
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(WorklistTaskDto.fromJS(item));
            }
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): WorklistDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorklistDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pertainingTo"] = this.pertainingTo ? this.pertainingTo.toJSON() : <any>undefined;
        data["template"] = this.template ? this.template.toJSON() : <any>undefined;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item.toJSON());
        }
        data["dueDate"] = this.dueDate ? formatDate(this.dueDate) : <any>undefined;
        data["status"] = this.status;
        return data;
    }
}

export interface IWorklistDto {
    id: string;
    pertainingTo?: IWorklistEmployeeDetailsDto | undefined;
    template: IWorklistTemplateDto;
    tasks: IWorklistTaskDto[];
    dueDate?: Date | undefined;
    status: WorklistDtoStatus;
}

export class BulkUpdateEmployeeTasksStatusInputDto implements IBulkUpdateEmployeeTasksStatusInputDto {
    taskStatus!: BulkUpdateEmployeeTasksStatusInputDtoTaskStatus;
    taskIds!: number[];

    constructor(data?: IBulkUpdateEmployeeTasksStatusInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.taskIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskStatus = _data["taskStatus"];
            if (Array.isArray(_data["taskIds"])) {
                this.taskIds = [] as any;
                for (let item of _data["taskIds"])
                    this.taskIds!.push(item);
            }
        }
    }

    static fromJS(data: any): BulkUpdateEmployeeTasksStatusInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new BulkUpdateEmployeeTasksStatusInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskStatus"] = this.taskStatus;
        if (Array.isArray(this.taskIds)) {
            data["taskIds"] = [];
            for (let item of this.taskIds)
                data["taskIds"].push(item);
        }
        return data;
    }
}

export interface IBulkUpdateEmployeeTasksStatusInputDto {
    taskStatus: BulkUpdateEmployeeTasksStatusInputDtoTaskStatus;
    taskIds: number[];
}

export class BulkUpdateWorklistTasksStatusInputDto implements IBulkUpdateWorklistTasksStatusInputDto {
    roles!: Roles3[];
    taskStatus!: BulkUpdateWorklistTasksStatusInputDtoTaskStatus;
    taskIds!: number[];
    treeId?: number;

    constructor(data?: IBulkUpdateWorklistTasksStatusInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.roles = [];
            this.taskIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.taskStatus = _data["taskStatus"];
            if (Array.isArray(_data["taskIds"])) {
                this.taskIds = [] as any;
                for (let item of _data["taskIds"])
                    this.taskIds!.push(item);
            }
            this.treeId = _data["treeId"];
        }
    }

    static fromJS(data: any): BulkUpdateWorklistTasksStatusInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new BulkUpdateWorklistTasksStatusInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["taskStatus"] = this.taskStatus;
        if (Array.isArray(this.taskIds)) {
            data["taskIds"] = [];
            for (let item of this.taskIds)
                data["taskIds"].push(item);
        }
        data["treeId"] = this.treeId;
        return data;
    }
}

export interface IBulkUpdateWorklistTasksStatusInputDto {
    roles: Roles3[];
    taskStatus: BulkUpdateWorklistTasksStatusInputDtoTaskStatus;
    taskIds: number[];
    treeId?: number;
}

export enum TrainingKindEnum {
    INTERNAL = "INTERNAL",
    EXTERNAL = "EXTERNAL",
    OTHER = "OTHER",
    COMPANY = "COMPANY",
}

export class TrainingKeyDto implements ITrainingKeyDto {
    id!: number;
    kind!: TrainingKindEnum;

    constructor(data?: ITrainingKeyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kind = _data["kind"];
        }
    }

    static fromJS(data: any): TrainingKeyDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingKeyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kind"] = this.kind;
        return data;
    }
}

export interface ITrainingKeyDto {
    id: number;
    kind: TrainingKindEnum;
}

export class TrainingDto implements ITrainingDto {
    key!: TrainingKeyDto;
    title!: string;
    description!: string;
    startDate!: Date;
    endDate?: Date | undefined;
    expirationDate?: Date | undefined;
    hours?: number | undefined;
    type!: EnumTranslationDto;
    classType?: EnumTranslationDto | undefined;
    employee!: EmployeeShortDto;

    constructor(data?: ITrainingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.key = data.key && !(<any>data.key).toJSON ? new TrainingKeyDto(data.key) : <TrainingKeyDto>this.key;
            this.type = data.type && !(<any>data.type).toJSON ? new EnumTranslationDto(data.type) : <EnumTranslationDto>this.type;
            this.classType = data.classType && !(<any>data.classType).toJSON ? new EnumTranslationDto(data.classType) : <EnumTranslationDto>this.classType;
            this.employee = data.employee && !(<any>data.employee).toJSON ? new EmployeeShortDto(data.employee) : <EmployeeShortDto>this.employee;
        }
        if (!data) {
            this.key = new TrainingKeyDto();
            this.type = new EnumTranslationDto();
            this.employee = new EmployeeShortDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] ? TrainingKeyDto.fromJS(_data["key"]) : new TrainingKeyDto();
            this.title = _data["title"];
            this.description = _data["description"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.hours = _data["hours"];
            this.type = _data["type"] ? EnumTranslationDto.fromJS(_data["type"]) : new EnumTranslationDto();
            this.classType = _data["classType"] ? EnumTranslationDto.fromJS(_data["classType"]) : <any>undefined;
            this.employee = _data["employee"] ? EmployeeShortDto.fromJS(_data["employee"]) : new EmployeeShortDto();
        }
    }

    static fromJS(data: any): TrainingDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key ? this.key.toJSON() : <any>undefined;
        data["title"] = this.title;
        data["description"] = this.description;
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>undefined;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : <any>undefined;
        data["expirationDate"] = this.expirationDate ? formatDate(this.expirationDate) : <any>undefined;
        data["hours"] = this.hours;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["classType"] = this.classType ? this.classType.toJSON() : <any>undefined;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITrainingDto {
    key: ITrainingKeyDto;
    title: string;
    description: string;
    startDate: Date;
    endDate?: Date | undefined;
    expirationDate?: Date | undefined;
    hours?: number | undefined;
    type: IEnumTranslationDto;
    classType?: IEnumTranslationDto | undefined;
    employee: IEmployeeShortDto;
}

export enum TrainingTypeGroupEnum {
    INTERNAL_TRAINING_TYPE = "INTERNAL_TRAINING_TYPE",
    EXTERNAL_TRAINING_TYPE = "EXTERNAL_TRAINING_TYPE",
    OTHER_TRAINING_TYPE = "OTHER_TRAINING_TYPE",
}

export class AnnouncementDto implements IAnnouncementDto {
    id!: number;
    message!: string;
    updatedAt!: Date;
    updatedBy?: EmployeeShortDto;

    constructor(data?: IAnnouncementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.updatedBy = data.updatedBy && !(<any>data.updatedBy).toJSON ? new EmployeeShortDto(data.updatedBy) : <EmployeeShortDto>this.updatedBy;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.message = _data["message"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"] ? EmployeeShortDto.fromJS(_data["updatedBy"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AnnouncementDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnnouncementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["message"] = this.message;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy ? this.updatedBy.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAnnouncementDto {
    id: number;
    message: string;
    updatedAt: Date;
    updatedBy?: IEmployeeShortDto;
}

export class AnnouncementDataDto implements IAnnouncementDataDto {
    message!: string;

    constructor(data?: IAnnouncementDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): AnnouncementDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnnouncementDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data;
    }
}

export interface IAnnouncementDataDto {
    message: string;
}

export enum AnniversaryTypeEnum {
    BIRTHDAY = "BIRTHDAY",
    WORK = "WORK",
}

export class AnniversaryDto implements IAnniversaryDto {
    type!: AnniversaryTypeEnum;
    date!: Date;
    years!: number;
    employee!: EmployeeShortDto;

    constructor(data?: IAnniversaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.employee = data.employee && !(<any>data.employee).toJSON ? new EmployeeShortDto(data.employee) : <EmployeeShortDto>this.employee;
        }
        if (!data) {
            this.employee = new EmployeeShortDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.years = _data["years"];
            this.employee = _data["employee"] ? EmployeeShortDto.fromJS(_data["employee"]) : new EmployeeShortDto();
        }
    }

    static fromJS(data: any): AnniversaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnniversaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["years"] = this.years;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAnniversaryDto {
    type: AnniversaryTypeEnum;
    date: Date;
    years: number;
    employee: IEmployeeShortDto;
}

export class NotificationTargetDto implements INotificationTargetDto {
    id!: string;
    type!: NotificationTargetDtoType;
    profilePic?: string;

    constructor(data?: INotificationTargetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.profilePic = _data["profilePic"];
        }
    }

    static fromJS(data: any): NotificationTargetDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationTargetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["profilePic"] = this.profilePic;
        return data;
    }
}

export interface INotificationTargetDto {
    id: string;
    type: NotificationTargetDtoType;
    profilePic?: string;
}

export class NotificationDto implements INotificationDto {
    id!: number;
    topic!: EnumTranslationDto;
    content!: string;
    target?: NotificationTargetDto;
    isRead!: boolean;
    createdAt!: Date;

    constructor(data?: INotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.topic = data.topic && !(<any>data.topic).toJSON ? new EnumTranslationDto(data.topic) : <EnumTranslationDto>this.topic;
            this.target = data.target && !(<any>data.target).toJSON ? new NotificationTargetDto(data.target) : <NotificationTargetDto>this.target;
        }
        if (!data) {
            this.topic = new EnumTranslationDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.topic = _data["topic"] ? EnumTranslationDto.fromJS(_data["topic"]) : new EnumTranslationDto();
            this.content = _data["content"];
            this.target = _data["target"] ? NotificationTargetDto.fromJS(_data["target"]) : <any>undefined;
            this.isRead = _data["isRead"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["topic"] = this.topic ? this.topic.toJSON() : <any>undefined;
        data["content"] = this.content;
        data["target"] = this.target ? this.target.toJSON() : <any>undefined;
        data["isRead"] = this.isRead;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface INotificationDto {
    id: number;
    topic: IEnumTranslationDto;
    content: string;
    target?: INotificationTargetDto;
    isRead: boolean;
    createdAt: Date;
}

export class QuickLinkNavigationDto implements IQuickLinkNavigationDto {
    module!: string;
    tab!: string;

    constructor(data?: IQuickLinkNavigationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.module = _data["module"];
            this.tab = _data["tab"];
        }
    }

    static fromJS(data: any): QuickLinkNavigationDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuickLinkNavigationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["module"] = this.module;
        data["tab"] = this.tab;
        return data;
    }
}

export interface IQuickLinkNavigationDto {
    module: string;
    tab: string;
}

export class QuickLinkTranslationDto implements IQuickLinkTranslationDto {
    name!: string;
    description?: string | undefined;
    language!: string;

    constructor(data?: IQuickLinkTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): QuickLinkTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuickLinkTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["language"] = this.language;
        return data;
    }
}

export interface IQuickLinkTranslationDto {
    name: string;
    description?: string | undefined;
    language: string;
}

export class QuickLinkDto implements IQuickLinkDto {
    id!: string;
    url?: string;
    location!: QuickLinkDtoLocation;
    navigation?: QuickLinkNavigationDto;
    roles!: string[];
    seq?: number;
    translations!: QuickLinkTranslationDto[];

    constructor(data?: IQuickLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.navigation = data.navigation && !(<any>data.navigation).toJSON ? new QuickLinkNavigationDto(data.navigation) : <QuickLinkNavigationDto>this.navigation;
            if (data.translations) {
                this.translations = [];
                for (let i = 0; i < data.translations.length; i++) {
                    let item = data.translations[i];
                    this.translations[i] = item && !(<any>item).toJSON ? new QuickLinkTranslationDto(item) : <QuickLinkTranslationDto>item;
                }
            }
        }
        if (!data) {
            this.roles = [];
            this.translations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.url = _data["url"];
            this.location = _data["location"];
            this.navigation = _data["navigation"] ? QuickLinkNavigationDto.fromJS(_data["navigation"]) : <any>undefined;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.seq = _data["seq"];
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations!.push(QuickLinkTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuickLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuickLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["url"] = this.url;
        data["location"] = this.location;
        data["navigation"] = this.navigation ? this.navigation.toJSON() : <any>undefined;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["seq"] = this.seq;
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQuickLinkDto {
    id: string;
    url?: string;
    location: QuickLinkDtoLocation;
    navigation?: IQuickLinkNavigationDto;
    roles: string[];
    seq?: number;
    translations: IQuickLinkTranslationDto[];
}

export class QuickLinkInputDto implements IQuickLinkInputDto {
    id?: string;
    name!: string;
    url?: string;
    location!: QuickLinkInputDtoLocation;
    navigation?: QuickLinkNavigationDto;
    seq?: number;
    roles?: string[];
    description?: string | undefined;
    language?: string;

    constructor(data?: IQuickLinkInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.navigation = data.navigation && !(<any>data.navigation).toJSON ? new QuickLinkNavigationDto(data.navigation) : <QuickLinkNavigationDto>this.navigation;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.url = _data["url"];
            this.location = _data["location"];
            this.navigation = _data["navigation"] ? QuickLinkNavigationDto.fromJS(_data["navigation"]) : <any>undefined;
            this.seq = _data["seq"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.description = _data["description"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): QuickLinkInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuickLinkInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["url"] = this.url;
        data["location"] = this.location;
        data["navigation"] = this.navigation ? this.navigation.toJSON() : <any>undefined;
        data["seq"] = this.seq;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["description"] = this.description;
        data["language"] = this.language;
        return data;
    }
}

export interface IQuickLinkInputDto {
    id?: string;
    name: string;
    url?: string;
    location: QuickLinkInputDtoLocation;
    navigation?: IQuickLinkNavigationDto;
    seq?: number;
    roles?: string[];
    description?: string | undefined;
    language?: string;
}

export class QuickLinkTranslationInputDto implements IQuickLinkTranslationInputDto {
    name!: string;
    description?: string | undefined;
    language!: string;

    constructor(data?: IQuickLinkTranslationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): QuickLinkTranslationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuickLinkTranslationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["language"] = this.language;
        return data;
    }
}

export interface IQuickLinkTranslationInputDto {
    name: string;
    description?: string | undefined;
    language: string;
}

export class SetQuickLinkTranslationsInputDto implements ISetQuickLinkTranslationsInputDto {
    translations?: QuickLinkTranslationInputDto[];

    constructor(data?: ISetQuickLinkTranslationsInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.translations) {
                this.translations = [];
                for (let i = 0; i < data.translations.length; i++) {
                    let item = data.translations[i];
                    this.translations[i] = item && !(<any>item).toJSON ? new QuickLinkTranslationInputDto(item) : <QuickLinkTranslationInputDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations!.push(QuickLinkTranslationInputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SetQuickLinkTranslationsInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetQuickLinkTranslationsInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISetQuickLinkTranslationsInputDto {
    translations?: IQuickLinkTranslationInputDto[];
}

export class BulkRemoveQuickLinksInputDto implements IBulkRemoveQuickLinksInputDto {
    ids!: string[];

    constructor(data?: IBulkRemoveQuickLinksInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ids = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): BulkRemoveQuickLinksInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new BulkRemoveQuickLinksInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface IBulkRemoveQuickLinksInputDto {
    ids: string[];
}

export class QuickLinkOrderInputDto implements IQuickLinkOrderInputDto {
    id!: string;
    seq!: number;

    constructor(data?: IQuickLinkOrderInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.seq = _data["seq"];
        }
    }

    static fromJS(data: any): QuickLinkOrderInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuickLinkOrderInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["seq"] = this.seq;
        return data;
    }
}

export interface IQuickLinkOrderInputDto {
    id: string;
    seq: number;
}

export class BulkUpdateOrderInputDto implements IBulkUpdateOrderInputDto {
    quickLinks!: QuickLinkOrderInputDto[];

    constructor(data?: IBulkUpdateOrderInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.quickLinks) {
                this.quickLinks = [];
                for (let i = 0; i < data.quickLinks.length; i++) {
                    let item = data.quickLinks[i];
                    this.quickLinks[i] = item && !(<any>item).toJSON ? new QuickLinkOrderInputDto(item) : <QuickLinkOrderInputDto>item;
                }
            }
        }
        if (!data) {
            this.quickLinks = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["quickLinks"])) {
                this.quickLinks = [] as any;
                for (let item of _data["quickLinks"])
                    this.quickLinks!.push(QuickLinkOrderInputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BulkUpdateOrderInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new BulkUpdateOrderInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.quickLinks)) {
            data["quickLinks"] = [];
            for (let item of this.quickLinks)
                data["quickLinks"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBulkUpdateOrderInputDto {
    quickLinks: IQuickLinkOrderInputDto[];
}

export enum CompanyPostStatusEnum {
    DRAFT = "DRAFT",
    INACTIVE = "INACTIVE",
    PUBLISHED = "PUBLISHED",
}

export class CompanyPostStatusTranslationDto implements ICompanyPostStatusTranslationDto {
    group!: string;
    code!: CompanyPostStatusEnum;
    language!: string | undefined;
    value!: string;

    constructor(data?: ICompanyPostStatusTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.group = _data["group"];
            this.code = _data["code"];
            this.language = _data["language"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CompanyPostStatusTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyPostStatusTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["group"] = this.group;
        data["code"] = this.code;
        data["language"] = this.language;
        data["value"] = this.value;
        return data;
    }
}

export interface ICompanyPostStatusTranslationDto {
    group: string;
    code: CompanyPostStatusEnum;
    language: string | undefined;
    value: string;
}

export class CompanyPostDto implements ICompanyPostDto {
    id!: number;
    status!: CompanyPostStatusTranslationDto;
    title!: string;
    content!: string;
    createdAt!: Date;
    createdBy!: EmployeeShortDto;
    publishedAt?: Date | undefined;
    publishedBy?: EmployeeShortDto | undefined;
    updatedAt?: Date | undefined;
    updatedBy?: EmployeeShortDto | undefined;

    constructor(data?: ICompanyPostDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.status = data.status && !(<any>data.status).toJSON ? new CompanyPostStatusTranslationDto(data.status) : <CompanyPostStatusTranslationDto>this.status;
            this.createdBy = data.createdBy && !(<any>data.createdBy).toJSON ? new EmployeeShortDto(data.createdBy) : <EmployeeShortDto>this.createdBy;
            this.publishedBy = data.publishedBy && !(<any>data.publishedBy).toJSON ? new EmployeeShortDto(data.publishedBy) : <EmployeeShortDto>this.publishedBy;
            this.updatedBy = data.updatedBy && !(<any>data.updatedBy).toJSON ? new EmployeeShortDto(data.updatedBy) : <EmployeeShortDto>this.updatedBy;
        }
        if (!data) {
            this.status = new CompanyPostStatusTranslationDto();
            this.createdBy = new EmployeeShortDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"] ? CompanyPostStatusTranslationDto.fromJS(_data["status"]) : new CompanyPostStatusTranslationDto();
            this.title = _data["title"];
            this.content = _data["content"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"] ? EmployeeShortDto.fromJS(_data["createdBy"]) : new EmployeeShortDto();
            this.publishedAt = _data["publishedAt"] ? new Date(_data["publishedAt"].toString()) : <any>undefined;
            this.publishedBy = _data["publishedBy"] ? EmployeeShortDto.fromJS(_data["publishedBy"]) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"] ? EmployeeShortDto.fromJS(_data["updatedBy"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CompanyPostDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyPostDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["title"] = this.title;
        data["content"] = this.content;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["publishedAt"] = this.publishedAt ? this.publishedAt.toISOString() : <any>undefined;
        data["publishedBy"] = this.publishedBy ? this.publishedBy.toJSON() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy ? this.updatedBy.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICompanyPostDto {
    id: number;
    status: ICompanyPostStatusTranslationDto;
    title: string;
    content: string;
    createdAt: Date;
    createdBy: IEmployeeShortDto;
    publishedAt?: Date | undefined;
    publishedBy?: IEmployeeShortDto | undefined;
    updatedAt?: Date | undefined;
    updatedBy?: IEmployeeShortDto | undefined;
}

export class TimesheetShortDto implements ITimesheetShortDto {
    id!: string;
    employee!: EmployeeShortDto;
    extraHoursBalance?: string;

    constructor(data?: ITimesheetShortDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.employee = data.employee && !(<any>data.employee).toJSON ? new EmployeeShortDto(data.employee) : <EmployeeShortDto>this.employee;
        }
        if (!data) {
            this.employee = new EmployeeShortDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employee = _data["employee"] ? EmployeeShortDto.fromJS(_data["employee"]) : new EmployeeShortDto();
            this.extraHoursBalance = _data["extraHoursBalance"];
        }
    }

    static fromJS(data: any): TimesheetShortDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetShortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["extraHoursBalance"] = this.extraHoursBalance;
        return data;
    }
}

export interface ITimesheetShortDto {
    id: string;
    employee: IEmployeeShortDto;
    extraHoursBalance?: string;
}

export class EvaluationSummaryDto implements IEvaluationSummaryDto {
    id!: string;
    templateId!: string;
    status!: string;
    employee!: EmployeeShortDto;
    dueDate!: Date | undefined;
    lastUpdatedAt!: Date | undefined;

    constructor(data?: IEvaluationSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.employee = data.employee && !(<any>data.employee).toJSON ? new EmployeeShortDto(data.employee) : <EmployeeShortDto>this.employee;
        }
        if (!data) {
            this.employee = new EmployeeShortDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.templateId = _data["templateId"];
            this.status = _data["status"];
            this.employee = _data["employee"] ? EmployeeShortDto.fromJS(_data["employee"]) : new EmployeeShortDto();
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EvaluationSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new EvaluationSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["templateId"] = this.templateId;
        data["status"] = this.status;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEvaluationSummaryDto {
    id: string;
    templateId: string;
    status: string;
    employee: IEmployeeShortDto;
    dueDate: Date | undefined;
    lastUpdatedAt: Date | undefined;
}

export class PerformanceGoalScoresDto implements IPerformanceGoalScoresDto {
    common!: number;
    personal!: number;
    total!: number;

    constructor(data?: IPerformanceGoalScoresDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.common = _data["common"];
            this.personal = _data["personal"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): PerformanceGoalScoresDto {
        data = typeof data === 'object' ? data : {};
        let result = new PerformanceGoalScoresDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["common"] = this.common;
        data["personal"] = this.personal;
        data["total"] = this.total;
        return data;
    }
}

export interface IPerformanceGoalScoresDto {
    common: number;
    personal: number;
    total: number;
}

export class PerformanceCommonGoalDto implements IPerformanceCommonGoalDto {
    id!: number;
    goalsetId?: number;
    rating!: EnumTranslationDto;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    target?: number;
    actual?: number;
    weight?: number;
    result?: number;
    info?: string;
    goalType!: EnumTranslationDto;
    successMeasure!: EnumTranslationDto;

    constructor(data?: IPerformanceCommonGoalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.rating = data.rating && !(<any>data.rating).toJSON ? new EnumTranslationDto(data.rating) : <EnumTranslationDto>this.rating;
            this.goalType = data.goalType && !(<any>data.goalType).toJSON ? new EnumTranslationDto(data.goalType) : <EnumTranslationDto>this.goalType;
            this.successMeasure = data.successMeasure && !(<any>data.successMeasure).toJSON ? new EnumTranslationDto(data.successMeasure) : <EnumTranslationDto>this.successMeasure;
        }
        if (!data) {
            this.rating = new EnumTranslationDto();
            this.goalType = new EnumTranslationDto();
            this.successMeasure = new EnumTranslationDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.goalsetId = _data["goalsetId"];
            this.rating = _data["rating"] ? EnumTranslationDto.fromJS(_data["rating"]) : new EnumTranslationDto();
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.target = _data["target"];
            this.actual = _data["actual"];
            this.weight = _data["weight"];
            this.result = _data["result"];
            this.info = _data["info"];
            this.goalType = _data["goalType"] ? EnumTranslationDto.fromJS(_data["goalType"]) : new EnumTranslationDto();
            this.successMeasure = _data["successMeasure"] ? EnumTranslationDto.fromJS(_data["successMeasure"]) : new EnumTranslationDto();
        }
    }

    static fromJS(data: any): PerformanceCommonGoalDto {
        data = typeof data === 'object' ? data : {};
        let result = new PerformanceCommonGoalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["goalsetId"] = this.goalsetId;
        data["rating"] = this.rating ? this.rating.toJSON() : <any>undefined;
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>undefined;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : <any>undefined;
        data["target"] = this.target;
        data["actual"] = this.actual;
        data["weight"] = this.weight;
        data["result"] = this.result;
        data["info"] = this.info;
        data["goalType"] = this.goalType ? this.goalType.toJSON() : <any>undefined;
        data["successMeasure"] = this.successMeasure ? this.successMeasure.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPerformanceCommonGoalDto {
    id: number;
    goalsetId?: number;
    rating: IEnumTranslationDto;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    target?: number;
    actual?: number;
    weight?: number;
    result?: number;
    info?: string;
    goalType: IEnumTranslationDto;
    successMeasure: IEnumTranslationDto;
}

export class PerformancePersonalGoalDto implements IPerformancePersonalGoalDto {
    id!: number;
    goalsetId?: number;
    rating!: EnumTranslationDto;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    target?: number;
    actual?: number;
    weight?: number;
    result?: number;
    info?: string;
    goalType!: string;
    successMeasure!: string;

    constructor(data?: IPerformancePersonalGoalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.rating = data.rating && !(<any>data.rating).toJSON ? new EnumTranslationDto(data.rating) : <EnumTranslationDto>this.rating;
        }
        if (!data) {
            this.rating = new EnumTranslationDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.goalsetId = _data["goalsetId"];
            this.rating = _data["rating"] ? EnumTranslationDto.fromJS(_data["rating"]) : new EnumTranslationDto();
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.target = _data["target"];
            this.actual = _data["actual"];
            this.weight = _data["weight"];
            this.result = _data["result"];
            this.info = _data["info"];
            this.goalType = _data["goalType"];
            this.successMeasure = _data["successMeasure"];
        }
    }

    static fromJS(data: any): PerformancePersonalGoalDto {
        data = typeof data === 'object' ? data : {};
        let result = new PerformancePersonalGoalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["goalsetId"] = this.goalsetId;
        data["rating"] = this.rating ? this.rating.toJSON() : <any>undefined;
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>undefined;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : <any>undefined;
        data["target"] = this.target;
        data["actual"] = this.actual;
        data["weight"] = this.weight;
        data["result"] = this.result;
        data["info"] = this.info;
        data["goalType"] = this.goalType;
        data["successMeasure"] = this.successMeasure;
        return data;
    }
}

export interface IPerformancePersonalGoalDto {
    id: number;
    goalsetId?: number;
    rating: IEnumTranslationDto;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    target?: number;
    actual?: number;
    weight?: number;
    result?: number;
    info?: string;
    goalType: string;
    successMeasure: string;
}

export class PerformanceGoalFullDto implements IPerformanceGoalFullDto {
    id?: number;
    type?: EnumTranslationDto;
    employee!: EmployeeShortDto;
    comment?: string | undefined;
    enteredAt?: Date;
    enteredBy?: EmployeeShortDto | undefined;
    scores!: PerformanceGoalScoresDto;
    commonGoals!: PerformanceCommonGoalDto[];
    personalGoals!: PerformancePersonalGoalDto[];

    constructor(data?: IPerformanceGoalFullDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.type = data.type && !(<any>data.type).toJSON ? new EnumTranslationDto(data.type) : <EnumTranslationDto>this.type;
            this.employee = data.employee && !(<any>data.employee).toJSON ? new EmployeeShortDto(data.employee) : <EmployeeShortDto>this.employee;
            this.enteredBy = data.enteredBy && !(<any>data.enteredBy).toJSON ? new EmployeeShortDto(data.enteredBy) : <EmployeeShortDto>this.enteredBy;
            this.scores = data.scores && !(<any>data.scores).toJSON ? new PerformanceGoalScoresDto(data.scores) : <PerformanceGoalScoresDto>this.scores;
            if (data.commonGoals) {
                this.commonGoals = [];
                for (let i = 0; i < data.commonGoals.length; i++) {
                    let item = data.commonGoals[i];
                    this.commonGoals[i] = item && !(<any>item).toJSON ? new PerformanceCommonGoalDto(item) : <PerformanceCommonGoalDto>item;
                }
            }
            if (data.personalGoals) {
                this.personalGoals = [];
                for (let i = 0; i < data.personalGoals.length; i++) {
                    let item = data.personalGoals[i];
                    this.personalGoals[i] = item && !(<any>item).toJSON ? new PerformancePersonalGoalDto(item) : <PerformancePersonalGoalDto>item;
                }
            }
        }
        if (!data) {
            this.employee = new EmployeeShortDto();
            this.scores = new PerformanceGoalScoresDto();
            this.commonGoals = [];
            this.personalGoals = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"] ? EnumTranslationDto.fromJS(_data["type"]) : <any>undefined;
            this.employee = _data["employee"] ? EmployeeShortDto.fromJS(_data["employee"]) : new EmployeeShortDto();
            this.comment = _data["comment"];
            this.enteredAt = _data["enteredAt"] ? new Date(_data["enteredAt"].toString()) : <any>undefined;
            this.enteredBy = _data["enteredBy"] ? EmployeeShortDto.fromJS(_data["enteredBy"]) : <any>undefined;
            this.scores = _data["scores"] ? PerformanceGoalScoresDto.fromJS(_data["scores"]) : new PerformanceGoalScoresDto();
            if (Array.isArray(_data["commonGoals"])) {
                this.commonGoals = [] as any;
                for (let item of _data["commonGoals"])
                    this.commonGoals!.push(PerformanceCommonGoalDto.fromJS(item));
            }
            if (Array.isArray(_data["personalGoals"])) {
                this.personalGoals = [] as any;
                for (let item of _data["personalGoals"])
                    this.personalGoals!.push(PerformancePersonalGoalDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PerformanceGoalFullDto {
        data = typeof data === 'object' ? data : {};
        let result = new PerformanceGoalFullDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["comment"] = this.comment;
        data["enteredAt"] = this.enteredAt ? this.enteredAt.toISOString() : <any>undefined;
        data["enteredBy"] = this.enteredBy ? this.enteredBy.toJSON() : <any>undefined;
        data["scores"] = this.scores ? this.scores.toJSON() : <any>undefined;
        if (Array.isArray(this.commonGoals)) {
            data["commonGoals"] = [];
            for (let item of this.commonGoals)
                data["commonGoals"].push(item.toJSON());
        }
        if (Array.isArray(this.personalGoals)) {
            data["personalGoals"] = [];
            for (let item of this.personalGoals)
                data["personalGoals"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPerformanceGoalFullDto {
    id?: number;
    type?: IEnumTranslationDto;
    employee: IEmployeeShortDto;
    comment?: string | undefined;
    enteredAt?: Date;
    enteredBy?: IEmployeeShortDto | undefined;
    scores: IPerformanceGoalScoresDto;
    commonGoals: IPerformanceCommonGoalDto[];
    personalGoals: IPerformancePersonalGoalDto[];
}

export class PerformanceGoalDto implements IPerformanceGoalDto {
    id?: number;
    type?: EnumTranslationDto;
    employee!: EmployeeShortDto;
    comment?: string | undefined;
    enteredAt?: Date;
    enteredBy?: EmployeeShortDto | undefined;
    scores!: PerformanceGoalScoresDto;

    constructor(data?: IPerformanceGoalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.type = data.type && !(<any>data.type).toJSON ? new EnumTranslationDto(data.type) : <EnumTranslationDto>this.type;
            this.employee = data.employee && !(<any>data.employee).toJSON ? new EmployeeShortDto(data.employee) : <EmployeeShortDto>this.employee;
            this.enteredBy = data.enteredBy && !(<any>data.enteredBy).toJSON ? new EmployeeShortDto(data.enteredBy) : <EmployeeShortDto>this.enteredBy;
            this.scores = data.scores && !(<any>data.scores).toJSON ? new PerformanceGoalScoresDto(data.scores) : <PerformanceGoalScoresDto>this.scores;
        }
        if (!data) {
            this.employee = new EmployeeShortDto();
            this.scores = new PerformanceGoalScoresDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"] ? EnumTranslationDto.fromJS(_data["type"]) : <any>undefined;
            this.employee = _data["employee"] ? EmployeeShortDto.fromJS(_data["employee"]) : new EmployeeShortDto();
            this.comment = _data["comment"];
            this.enteredAt = _data["enteredAt"] ? new Date(_data["enteredAt"].toString()) : <any>undefined;
            this.enteredBy = _data["enteredBy"] ? EmployeeShortDto.fromJS(_data["enteredBy"]) : <any>undefined;
            this.scores = _data["scores"] ? PerformanceGoalScoresDto.fromJS(_data["scores"]) : new PerformanceGoalScoresDto();
        }
    }

    static fromJS(data: any): PerformanceGoalDto {
        data = typeof data === 'object' ? data : {};
        let result = new PerformanceGoalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["comment"] = this.comment;
        data["enteredAt"] = this.enteredAt ? this.enteredAt.toISOString() : <any>undefined;
        data["enteredBy"] = this.enteredBy ? this.enteredBy.toJSON() : <any>undefined;
        data["scores"] = this.scores ? this.scores.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPerformanceGoalDto {
    id?: number;
    type?: IEnumTranslationDto;
    employee: IEmployeeShortDto;
    comment?: string | undefined;
    enteredAt?: Date;
    enteredBy?: IEmployeeShortDto | undefined;
    scores: IPerformanceGoalScoresDto;
}

export class CompensationDto implements ICompensationDto {
    id!: number;
    startDate!: Date;
    endDate?: Date | undefined;
    info?: string | undefined;
    baseSalary!: number;
    salaryFrequency!: string;
    totalAllowances!: number;
    totalBenefits!: number;
    totalCompensation!: number;
    currency!: string;
    effectiveDate?: Date | undefined;
    employee?: EmployeeShortDto | undefined;
    isHistorical!: boolean;

    constructor(data?: ICompensationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.employee = data.employee && !(<any>data.employee).toJSON ? new EmployeeShortDto(data.employee) : <EmployeeShortDto>this.employee;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.info = _data["info"];
            this.baseSalary = _data["baseSalary"];
            this.salaryFrequency = _data["salaryFrequency"];
            this.totalAllowances = _data["totalAllowances"];
            this.totalBenefits = _data["totalBenefits"];
            this.totalCompensation = _data["totalCompensation"];
            this.currency = _data["currency"];
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : <any>undefined;
            this.employee = _data["employee"] ? EmployeeShortDto.fromJS(_data["employee"]) : <any>undefined;
            this.isHistorical = _data["isHistorical"];
        }
    }

    static fromJS(data: any): CompensationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompensationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>undefined;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : <any>undefined;
        data["info"] = this.info;
        data["baseSalary"] = this.baseSalary;
        data["salaryFrequency"] = this.salaryFrequency;
        data["totalAllowances"] = this.totalAllowances;
        data["totalBenefits"] = this.totalBenefits;
        data["totalCompensation"] = this.totalCompensation;
        data["currency"] = this.currency;
        data["effectiveDate"] = this.effectiveDate ? formatDate(this.effectiveDate) : <any>undefined;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["isHistorical"] = this.isHistorical;
        return data;
    }
}

export interface ICompensationDto {
    id: number;
    startDate: Date;
    endDate?: Date | undefined;
    info?: string | undefined;
    baseSalary: number;
    salaryFrequency: string;
    totalAllowances: number;
    totalBenefits: number;
    totalCompensation: number;
    currency: string;
    effectiveDate?: Date | undefined;
    employee?: IEmployeeShortDto | undefined;
    isHistorical: boolean;
}

export class PaidShortIncentiveDto implements IPaidShortIncentiveDto {
    id!: number;
    info?: string | undefined;
    paymentAmount!: number;
    paymentDate!: Date;
    approvalDate?: Date | undefined;
    paymentPeriod?: string | undefined;
    currency!: string;
    incentiveType!: EnumTranslationDto;

    constructor(data?: IPaidShortIncentiveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.incentiveType = data.incentiveType && !(<any>data.incentiveType).toJSON ? new EnumTranslationDto(data.incentiveType) : <EnumTranslationDto>this.incentiveType;
        }
        if (!data) {
            this.incentiveType = new EnumTranslationDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.info = _data["info"];
            this.paymentAmount = _data["paymentAmount"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : <any>undefined;
            this.approvalDate = _data["approvalDate"] ? new Date(_data["approvalDate"].toString()) : <any>undefined;
            this.paymentPeriod = _data["paymentPeriod"];
            this.currency = _data["currency"];
            this.incentiveType = _data["incentiveType"] ? EnumTranslationDto.fromJS(_data["incentiveType"]) : new EnumTranslationDto();
        }
    }

    static fromJS(data: any): PaidShortIncentiveDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaidShortIncentiveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["info"] = this.info;
        data["paymentAmount"] = this.paymentAmount;
        data["paymentDate"] = this.paymentDate ? formatDate(this.paymentDate) : <any>undefined;
        data["approvalDate"] = this.approvalDate ? formatDate(this.approvalDate) : <any>undefined;
        data["paymentPeriod"] = this.paymentPeriod;
        data["currency"] = this.currency;
        data["incentiveType"] = this.incentiveType ? this.incentiveType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPaidShortIncentiveDto {
    id: number;
    info?: string | undefined;
    paymentAmount: number;
    paymentDate: Date;
    approvalDate?: Date | undefined;
    paymentPeriod?: string | undefined;
    currency: string;
    incentiveType: IEnumTranslationDto;
}

export class CompensationsSummaryDto implements ICompensationsSummaryDto {
    employee!: EmployeeShortDto;
    current!: CompensationDto;
    history!: CompensationDto[];
    latestPaidIncentives!: PaidShortIncentiveDto[];

    constructor(data?: ICompensationsSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.employee = data.employee && !(<any>data.employee).toJSON ? new EmployeeShortDto(data.employee) : <EmployeeShortDto>this.employee;
            this.current = data.current && !(<any>data.current).toJSON ? new CompensationDto(data.current) : <CompensationDto>this.current;
            if (data.history) {
                this.history = [];
                for (let i = 0; i < data.history.length; i++) {
                    let item = data.history[i];
                    this.history[i] = item && !(<any>item).toJSON ? new CompensationDto(item) : <CompensationDto>item;
                }
            }
            if (data.latestPaidIncentives) {
                this.latestPaidIncentives = [];
                for (let i = 0; i < data.latestPaidIncentives.length; i++) {
                    let item = data.latestPaidIncentives[i];
                    this.latestPaidIncentives[i] = item && !(<any>item).toJSON ? new PaidShortIncentiveDto(item) : <PaidShortIncentiveDto>item;
                }
            }
        }
        if (!data) {
            this.employee = new EmployeeShortDto();
            this.current = new CompensationDto();
            this.history = [];
            this.latestPaidIncentives = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employee = _data["employee"] ? EmployeeShortDto.fromJS(_data["employee"]) : new EmployeeShortDto();
            this.current = _data["current"] ? CompensationDto.fromJS(_data["current"]) : new CompensationDto();
            if (Array.isArray(_data["history"])) {
                this.history = [] as any;
                for (let item of _data["history"])
                    this.history!.push(CompensationDto.fromJS(item));
            }
            if (Array.isArray(_data["latestPaidIncentives"])) {
                this.latestPaidIncentives = [] as any;
                for (let item of _data["latestPaidIncentives"])
                    this.latestPaidIncentives!.push(PaidShortIncentiveDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CompensationsSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompensationsSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["current"] = this.current ? this.current.toJSON() : <any>undefined;
        if (Array.isArray(this.history)) {
            data["history"] = [];
            for (let item of this.history)
                data["history"].push(item.toJSON());
        }
        if (Array.isArray(this.latestPaidIncentives)) {
            data["latestPaidIncentives"] = [];
            for (let item of this.latestPaidIncentives)
                data["latestPaidIncentives"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICompensationsSummaryDto {
    employee: IEmployeeShortDto;
    current: ICompensationDto;
    history: ICompensationDto[];
    latestPaidIncentives: IPaidShortIncentiveDto[];
}

export class DevelopmentPlanActivityDto implements IDevelopmentPlanActivityDto {
    id!: number;
    area?: string | undefined;
    action?: string | undefined;
    method?: string | undefined;
    goal?: string | undefined;
    info?: string | undefined;
    rating?: number | undefined;
    endDate?: Date | undefined;
    methodType!: EnumTranslationDto;

    constructor(data?: IDevelopmentPlanActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.methodType = data.methodType && !(<any>data.methodType).toJSON ? new EnumTranslationDto(data.methodType) : <EnumTranslationDto>this.methodType;
        }
        if (!data) {
            this.methodType = new EnumTranslationDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.area = _data["area"];
            this.action = _data["action"];
            this.method = _data["method"];
            this.goal = _data["goal"];
            this.info = _data["info"];
            this.rating = _data["rating"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.methodType = _data["methodType"] ? EnumTranslationDto.fromJS(_data["methodType"]) : new EnumTranslationDto();
        }
    }

    static fromJS(data: any): DevelopmentPlanActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new DevelopmentPlanActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["area"] = this.area;
        data["action"] = this.action;
        data["method"] = this.method;
        data["goal"] = this.goal;
        data["info"] = this.info;
        data["rating"] = this.rating;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : <any>undefined;
        data["methodType"] = this.methodType ? this.methodType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDevelopmentPlanActivityDto {
    id: number;
    area?: string | undefined;
    action?: string | undefined;
    method?: string | undefined;
    goal?: string | undefined;
    info?: string | undefined;
    rating?: number | undefined;
    endDate?: Date | undefined;
    methodType: IEnumTranslationDto;
}

export class DevelopmentPlanDescriptionDto implements IDevelopmentPlanDescriptionDto {
    careerAspirations?: string | undefined;
    developmentFocus?: string | undefined;
    horizontalInterest?: boolean | undefined;
    internationalInterest?: boolean | undefined;

    constructor(data?: IDevelopmentPlanDescriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.careerAspirations = _data["careerAspirations"];
            this.developmentFocus = _data["developmentFocus"];
            this.horizontalInterest = _data["horizontalInterest"];
            this.internationalInterest = _data["internationalInterest"];
        }
    }

    static fromJS(data: any): DevelopmentPlanDescriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new DevelopmentPlanDescriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["careerAspirations"] = this.careerAspirations;
        data["developmentFocus"] = this.developmentFocus;
        data["horizontalInterest"] = this.horizontalInterest;
        data["internationalInterest"] = this.internationalInterest;
        return data;
    }
}

export interface IDevelopmentPlanDescriptionDto {
    careerAspirations?: string | undefined;
    developmentFocus?: string | undefined;
    horizontalInterest?: boolean | undefined;
    internationalInterest?: boolean | undefined;
}

export class DevelopmentPlanDto implements IDevelopmentPlanDto {
    id!: number;
    activities!: DevelopmentPlanActivityDto;
    description!: DevelopmentPlanDescriptionDto;
    employee!: EmployeeShortDto;
    type!: EnumTranslationDto;
    comment?: string | undefined;
    enteredTime!: Date;
    enteredBy?: EmployeeShortDto;
    isHistorical!: boolean;

    constructor(data?: IDevelopmentPlanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.activities = data.activities && !(<any>data.activities).toJSON ? new DevelopmentPlanActivityDto(data.activities) : <DevelopmentPlanActivityDto>this.activities;
            this.description = data.description && !(<any>data.description).toJSON ? new DevelopmentPlanDescriptionDto(data.description) : <DevelopmentPlanDescriptionDto>this.description;
            this.employee = data.employee && !(<any>data.employee).toJSON ? new EmployeeShortDto(data.employee) : <EmployeeShortDto>this.employee;
            this.type = data.type && !(<any>data.type).toJSON ? new EnumTranslationDto(data.type) : <EnumTranslationDto>this.type;
            this.enteredBy = data.enteredBy && !(<any>data.enteredBy).toJSON ? new EmployeeShortDto(data.enteredBy) : <EmployeeShortDto>this.enteredBy;
        }
        if (!data) {
            this.activities = new DevelopmentPlanActivityDto();
            this.description = new DevelopmentPlanDescriptionDto();
            this.employee = new EmployeeShortDto();
            this.type = new EnumTranslationDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.activities = _data["activities"] ? DevelopmentPlanActivityDto.fromJS(_data["activities"]) : new DevelopmentPlanActivityDto();
            this.description = _data["description"] ? DevelopmentPlanDescriptionDto.fromJS(_data["description"]) : new DevelopmentPlanDescriptionDto();
            this.employee = _data["employee"] ? EmployeeShortDto.fromJS(_data["employee"]) : new EmployeeShortDto();
            this.type = _data["type"] ? EnumTranslationDto.fromJS(_data["type"]) : new EnumTranslationDto();
            this.comment = _data["comment"];
            this.enteredTime = _data["enteredTime"] ? new Date(_data["enteredTime"].toString()) : <any>undefined;
            this.enteredBy = _data["enteredBy"] ? EmployeeShortDto.fromJS(_data["enteredBy"]) : <any>undefined;
            this.isHistorical = _data["isHistorical"];
        }
    }

    static fromJS(data: any): DevelopmentPlanDto {
        data = typeof data === 'object' ? data : {};
        let result = new DevelopmentPlanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activities"] = this.activities ? this.activities.toJSON() : <any>undefined;
        data["description"] = this.description ? this.description.toJSON() : <any>undefined;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["comment"] = this.comment;
        data["enteredTime"] = this.enteredTime ? formatDate(this.enteredTime) : <any>undefined;
        data["enteredBy"] = this.enteredBy ? this.enteredBy.toJSON() : <any>undefined;
        data["isHistorical"] = this.isHistorical;
        return data;
    }
}

export interface IDevelopmentPlanDto {
    id: number;
    activities: IDevelopmentPlanActivityDto;
    description: IDevelopmentPlanDescriptionDto;
    employee: IEmployeeShortDto;
    type: IEnumTranslationDto;
    comment?: string | undefined;
    enteredTime: Date;
    enteredBy?: IEmployeeShortDto;
    isHistorical: boolean;
}

export class EmploymentDto implements IEmploymentDto {
    id!: number;
    employeeId!: number;
    type!: string;
    details!: number;
    arrivalDate!: Date;
    trialPeriod!: string | undefined;
    endDate!: Date | undefined;
    terminationDate!: Date | undefined;
    fixedTermReason!: EnumTranslationDto | undefined;
    currency!: EnumTranslationDto;
    startDate!: Date;
    enteredTime!: Date;
    enteredBy!: number;
    supersededTime!: Date | undefined;
    supersededBy!: number | undefined;
    supersededReason!: string | undefined;
    terminationReason!: EnumTranslationDto | undefined;
    trialPeriodEndDate!: Date | undefined;
    plannedEndDate!: Date | undefined;
    updatedAt!: Date;
    info!: string | undefined;

    constructor(data?: IEmploymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.fixedTermReason = data.fixedTermReason && !(<any>data.fixedTermReason).toJSON ? new EnumTranslationDto(data.fixedTermReason) : <EnumTranslationDto>this.fixedTermReason;
            this.currency = data.currency && !(<any>data.currency).toJSON ? new EnumTranslationDto(data.currency) : <EnumTranslationDto>this.currency;
            this.terminationReason = data.terminationReason && !(<any>data.terminationReason).toJSON ? new EnumTranslationDto(data.terminationReason) : <EnumTranslationDto>this.terminationReason;
        }
        if (!data) {
            this.currency = new EnumTranslationDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeId = _data["employeeId"];
            this.type = _data["type"];
            this.details = _data["details"];
            this.arrivalDate = _data["arrivalDate"] ? new Date(_data["arrivalDate"].toString()) : <any>undefined;
            this.trialPeriod = _data["trialPeriod"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.terminationDate = _data["terminationDate"] ? new Date(_data["terminationDate"].toString()) : <any>undefined;
            this.fixedTermReason = _data["fixedTermReason"] ? EnumTranslationDto.fromJS(_data["fixedTermReason"]) : <any>undefined;
            this.currency = _data["currency"] ? EnumTranslationDto.fromJS(_data["currency"]) : new EnumTranslationDto();
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.enteredTime = _data["enteredTime"] ? new Date(_data["enteredTime"].toString()) : <any>undefined;
            this.enteredBy = _data["enteredBy"];
            this.supersededTime = _data["supersededTime"] ? new Date(_data["supersededTime"].toString()) : <any>undefined;
            this.supersededBy = _data["supersededBy"];
            this.supersededReason = _data["supersededReason"];
            this.terminationReason = _data["terminationReason"] ? EnumTranslationDto.fromJS(_data["terminationReason"]) : <any>undefined;
            this.trialPeriodEndDate = _data["trialPeriodEndDate"] ? new Date(_data["trialPeriodEndDate"].toString()) : <any>undefined;
            this.plannedEndDate = _data["plannedEndDate"] ? new Date(_data["plannedEndDate"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.info = _data["info"];
        }
    }

    static fromJS(data: any): EmploymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmploymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeId"] = this.employeeId;
        data["type"] = this.type;
        data["details"] = this.details;
        data["arrivalDate"] = this.arrivalDate ? formatDate(this.arrivalDate) : <any>undefined;
        data["trialPeriod"] = this.trialPeriod;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : <any>undefined;
        data["terminationDate"] = this.terminationDate ? formatDate(this.terminationDate) : <any>undefined;
        data["fixedTermReason"] = this.fixedTermReason ? this.fixedTermReason.toJSON() : <any>undefined;
        data["currency"] = this.currency ? this.currency.toJSON() : <any>undefined;
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>undefined;
        data["enteredTime"] = this.enteredTime ? formatDate(this.enteredTime) : <any>undefined;
        data["enteredBy"] = this.enteredBy;
        data["supersededTime"] = this.supersededTime ? formatDate(this.supersededTime) : <any>undefined;
        data["supersededBy"] = this.supersededBy;
        data["supersededReason"] = this.supersededReason;
        data["terminationReason"] = this.terminationReason ? this.terminationReason.toJSON() : <any>undefined;
        data["trialPeriodEndDate"] = this.trialPeriodEndDate ? formatDate(this.trialPeriodEndDate) : <any>undefined;
        data["plannedEndDate"] = this.plannedEndDate ? formatDate(this.plannedEndDate) : <any>undefined;
        data["updatedAt"] = this.updatedAt ? formatDate(this.updatedAt) : <any>undefined;
        data["info"] = this.info;
        return data;
    }
}

export interface IEmploymentDto {
    id: number;
    employeeId: number;
    type: string;
    details: number;
    arrivalDate: Date;
    trialPeriod: string | undefined;
    endDate: Date | undefined;
    terminationDate: Date | undefined;
    fixedTermReason: IEnumTranslationDto | undefined;
    currency: IEnumTranslationDto;
    startDate: Date;
    enteredTime: Date;
    enteredBy: number;
    supersededTime: Date | undefined;
    supersededBy: number | undefined;
    supersededReason: string | undefined;
    terminationReason: IEnumTranslationDto | undefined;
    trialPeriodEndDate: Date | undefined;
    plannedEndDate: Date | undefined;
    updatedAt: Date;
    info: string | undefined;
}

export class RelationsEmployeeDto implements IRelationsEmployeeDto {
    id!: number;
    userId!: number | undefined;
    username!: string | undefined;
    employeeNumber!: string;
    firstName!: string;
    lastName!: string;
    profilePic?: string | undefined;
    positionName!: EnumTranslationDto;
    managerId!: number | undefined;
    higherManagerId!: number | undefined;

    constructor(data?: IRelationsEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.positionName = data.positionName && !(<any>data.positionName).toJSON ? new EnumTranslationDto(data.positionName) : <EnumTranslationDto>this.positionName;
        }
        if (!data) {
            this.positionName = new EnumTranslationDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.username = _data["username"];
            this.employeeNumber = _data["employeeNumber"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.profilePic = _data["profilePic"];
            this.positionName = _data["positionName"] ? EnumTranslationDto.fromJS(_data["positionName"]) : new EnumTranslationDto();
            this.managerId = _data["managerId"];
            this.higherManagerId = _data["higherManagerId"];
        }
    }

    static fromJS(data: any): RelationsEmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new RelationsEmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["username"] = this.username;
        data["employeeNumber"] = this.employeeNumber;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["profilePic"] = this.profilePic;
        data["positionName"] = this.positionName ? this.positionName.toJSON() : <any>undefined;
        data["managerId"] = this.managerId;
        data["higherManagerId"] = this.higherManagerId;
        return data;
    }
}

export interface IRelationsEmployeeDto {
    id: number;
    userId: number | undefined;
    username: string | undefined;
    employeeNumber: string;
    firstName: string;
    lastName: string;
    profilePic?: string | undefined;
    positionName: IEnumTranslationDto;
    managerId: number | undefined;
    higherManagerId: number | undefined;
}

export class RelationsEmploymentDetailsDto implements IRelationsEmploymentDetailsDto {
    employmentStatus!: EnumTranslationDto;
    jobGrade?: EnumTranslationDto;
    isPending!: boolean;

    constructor(data?: IRelationsEmploymentDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.employmentStatus = data.employmentStatus && !(<any>data.employmentStatus).toJSON ? new EnumTranslationDto(data.employmentStatus) : <EnumTranslationDto>this.employmentStatus;
            this.jobGrade = data.jobGrade && !(<any>data.jobGrade).toJSON ? new EnumTranslationDto(data.jobGrade) : <EnumTranslationDto>this.jobGrade;
        }
        if (!data) {
            this.employmentStatus = new EnumTranslationDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employmentStatus = _data["employmentStatus"] ? EnumTranslationDto.fromJS(_data["employmentStatus"]) : new EnumTranslationDto();
            this.jobGrade = _data["jobGrade"] ? EnumTranslationDto.fromJS(_data["jobGrade"]) : <any>undefined;
            this.isPending = _data["isPending"];
        }
    }

    static fromJS(data: any): RelationsEmploymentDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new RelationsEmploymentDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employmentStatus"] = this.employmentStatus ? this.employmentStatus.toJSON() : <any>undefined;
        data["jobGrade"] = this.jobGrade ? this.jobGrade.toJSON() : <any>undefined;
        data["isPending"] = this.isPending;
        return data;
    }
}

export interface IRelationsEmploymentDetailsDto {
    employmentStatus: IEnumTranslationDto;
    jobGrade?: IEnumTranslationDto;
    isPending: boolean;
}

export class RelationsEmploymentDto implements IRelationsEmploymentDto {
    id!: number;
    startDate!: Date;
    endDate?: Date | undefined;
    info?: string | undefined;
    type!: EnumTranslationDto;
    currency!: EnumTranslationDto;
    details!: RelationsEmploymentDetailsDto;

    constructor(data?: IRelationsEmploymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.type = data.type && !(<any>data.type).toJSON ? new EnumTranslationDto(data.type) : <EnumTranslationDto>this.type;
            this.currency = data.currency && !(<any>data.currency).toJSON ? new EnumTranslationDto(data.currency) : <EnumTranslationDto>this.currency;
            this.details = data.details && !(<any>data.details).toJSON ? new RelationsEmploymentDetailsDto(data.details) : <RelationsEmploymentDetailsDto>this.details;
        }
        if (!data) {
            this.type = new EnumTranslationDto();
            this.currency = new EnumTranslationDto();
            this.details = new RelationsEmploymentDetailsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.info = _data["info"];
            this.type = _data["type"] ? EnumTranslationDto.fromJS(_data["type"]) : new EnumTranslationDto();
            this.currency = _data["currency"] ? EnumTranslationDto.fromJS(_data["currency"]) : new EnumTranslationDto();
            this.details = _data["details"] ? RelationsEmploymentDetailsDto.fromJS(_data["details"]) : new RelationsEmploymentDetailsDto();
        }
    }

    static fromJS(data: any): RelationsEmploymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new RelationsEmploymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>undefined;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : <any>undefined;
        data["info"] = this.info;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["currency"] = this.currency ? this.currency.toJSON() : <any>undefined;
        data["details"] = this.details ? this.details.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRelationsEmploymentDto {
    id: number;
    startDate: Date;
    endDate?: Date | undefined;
    info?: string | undefined;
    type: IEnumTranslationDto;
    currency: IEnumTranslationDto;
    details: IRelationsEmploymentDetailsDto;
}

export class RelationsUnitDto implements IRelationsUnitDto {
    id!: number;
    code!: string;
    name!: string;
    type!: EnumTranslationDto;

    constructor(data?: IRelationsUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.type = data.type && !(<any>data.type).toJSON ? new EnumTranslationDto(data.type) : <EnumTranslationDto>this.type;
        }
        if (!data) {
            this.type = new EnumTranslationDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.type = _data["type"] ? EnumTranslationDto.fromJS(_data["type"]) : new EnumTranslationDto();
        }
    }

    static fromJS(data: any): RelationsUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new RelationsUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRelationsUnitDto {
    id: number;
    code: string;
    name: string;
    type: IEnumTranslationDto;
}

export class RelationsDto implements IRelationsDto {
    employees!: { [key: string]: RelationsEmployeeDto; };
    employments!: { [key: string]: RelationsEmploymentDto; };
    units!: { [key: string]: RelationsUnitDto; };

    constructor(data?: IRelationsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.employees) {
                this.employees = {};
                for (let key in data.employees) {
                    if (data.employees.hasOwnProperty(key)) {
                        let item = data.employees[key];
                        this.employees[key] = item && !(<any>item).toJSON ? new RelationsEmployeeDto(item) : <RelationsEmployeeDto>item;
                    }
                }
            }
            if (data.employments) {
                this.employments = {};
                for (let key in data.employments) {
                    if (data.employments.hasOwnProperty(key)) {
                        let item = data.employments[key];
                        this.employments[key] = item && !(<any>item).toJSON ? new RelationsEmploymentDto(item) : <RelationsEmploymentDto>item;
                    }
                }
            }
            if (data.units) {
                this.units = {};
                for (let key in data.units) {
                    if (data.units.hasOwnProperty(key)) {
                        let item = data.units[key];
                        this.units[key] = item && !(<any>item).toJSON ? new RelationsUnitDto(item) : <RelationsUnitDto>item;
                    }
                }
            }
        }
        if (!data) {
            this.employees = {};
            this.employments = {};
            this.units = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["employees"]) {
                this.employees = {} as any;
                for (let key in _data["employees"]) {
                    if (_data["employees"].hasOwnProperty(key))
                        (<any>this.employees)![key] = _data["employees"][key] ? RelationsEmployeeDto.fromJS(_data["employees"][key]) : new RelationsEmployeeDto();
                }
            }
            if (_data["employments"]) {
                this.employments = {} as any;
                for (let key in _data["employments"]) {
                    if (_data["employments"].hasOwnProperty(key))
                        (<any>this.employments)![key] = _data["employments"][key] ? RelationsEmploymentDto.fromJS(_data["employments"][key]) : new RelationsEmploymentDto();
                }
            }
            if (_data["units"]) {
                this.units = {} as any;
                for (let key in _data["units"]) {
                    if (_data["units"].hasOwnProperty(key))
                        (<any>this.units)![key] = _data["units"][key] ? RelationsUnitDto.fromJS(_data["units"][key]) : new RelationsUnitDto();
                }
            }
        }
    }

    static fromJS(data: any): RelationsDto {
        data = typeof data === 'object' ? data : {};
        let result = new RelationsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.employees) {
            data["employees"] = {};
            for (let key in this.employees) {
                if (this.employees.hasOwnProperty(key))
                    (<any>data["employees"])[key] = this.employees[key] ? this.employees[key].toJSON() : <any>undefined;
            }
        }
        if (this.employments) {
            data["employments"] = {};
            for (let key in this.employments) {
                if (this.employments.hasOwnProperty(key))
                    (<any>data["employments"])[key] = this.employments[key] ? this.employments[key].toJSON() : <any>undefined;
            }
        }
        if (this.units) {
            data["units"] = {};
            for (let key in this.units) {
                if (this.units.hasOwnProperty(key))
                    (<any>data["units"])[key] = this.units[key] ? this.units[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IRelationsDto {
    employees: { [key: string]: IRelationsEmployeeDto; };
    employments: { [key: string]: IRelationsEmploymentDto; };
    units: { [key: string]: IRelationsUnitDto; };
}

export enum Order {
    Asc = "asc",
    Desc = "desc",
}

export enum Order2 {
    Asc = "asc",
    Desc = "desc",
}

export enum Order3 {
    Asc = "asc",
    Desc = "desc",
}

export enum Order4 {
    Asc = "asc",
    Desc = "desc",
}

export enum Order5 {
    Asc = "asc",
    Desc = "desc",
}

export enum Order6 {
    Asc = "asc",
    Desc = "desc",
}

export enum Order7 {
    Asc = "asc",
    Desc = "desc",
}

export enum Order8 {
    Asc = "asc",
    Desc = "desc",
}

export enum Order9 {
    Asc = "asc",
    Desc = "desc",
}

export enum Order10 {
    Asc = "asc",
    Desc = "desc",
}

export enum Order11 {
    Asc = "asc",
    Desc = "desc",
}

export enum Order12 {
    Asc = "asc",
    Desc = "desc",
}

export enum Roles {
    ADMIN = "ADMIN",
    EMPLOYEE = "EMPLOYEE",
    MANAGER = "MANAGER",
    ALT_MANAGER = "ALT_MANAGER",
    DEPUTY_MANAGER = "DEPUTY_MANAGER",
    HR_ADMIN = "HR_ADMIN",
    HR_STAFF = "HR_STAFF",
}

export enum Order13 {
    Asc = "asc",
    Desc = "desc",
}

export enum Roles2 {
    ADMIN = "ADMIN",
    EMPLOYEE = "EMPLOYEE",
    MANAGER = "MANAGER",
    ALT_MANAGER = "ALT_MANAGER",
    DEPUTY_MANAGER = "DEPUTY_MANAGER",
    HR_ADMIN = "HR_ADMIN",
    HR_STAFF = "HR_STAFF",
}

export enum Order14 {
    Asc = "asc",
    Desc = "desc",
}

export enum Order15 {
    Asc = "asc",
    Desc = "desc",
}

export enum Order16 {
    Asc = "asc",
    Desc = "desc",
}

export enum Order17 {
    Asc = "asc",
    Desc = "desc",
}

export enum Order18 {
    Asc = "asc",
    Desc = "desc",
}

export enum Order19 {
    Asc = "asc",
    Desc = "desc",
}

export enum Order20 {
    Asc = "asc",
    Desc = "desc",
}

export enum Order21 {
    Asc = "asc",
    Desc = "desc",
}

export enum Order22 {
    Asc = "asc",
    Desc = "desc",
}

export enum Order23 {
    Asc = "asc",
    Desc = "desc",
}

export enum Order24 {
    Asc = "asc",
    Desc = "desc",
}

export enum Order25 {
    Asc = "asc",
    Desc = "desc",
}

export enum Order26 {
    Asc = "asc",
    Desc = "desc",
}

export enum Order27 {
    Asc = "asc",
    Desc = "desc",
}

export enum Order28 {
    Asc = "asc",
    Desc = "desc",
}

export enum Order29 {
    Asc = "asc",
    Desc = "desc",
}

export class AbsenceListResultDto implements IAbsenceListResultDto {
    data!: AbsenceDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: IAbsenceListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new AbsenceDto(item) : <AbsenceDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AbsenceDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): AbsenceListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AbsenceListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IAbsenceListResultDto {
    data: IAbsenceDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export class AbsenceListResultDto2 implements IAbsenceListResultDto2 {
    data!: AbsenceDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: IAbsenceListResultDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new AbsenceDto(item) : <AbsenceDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AbsenceDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): AbsenceListResultDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new AbsenceListResultDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IAbsenceListResultDto2 {
    data: IAbsenceDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export class AbsenceListResultDto3 implements IAbsenceListResultDto3 {
    data!: AbsenceDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: IAbsenceListResultDto3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new AbsenceDto(item) : <AbsenceDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AbsenceDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): AbsenceListResultDto3 {
        data = typeof data === 'object' ? data : {};
        let result = new AbsenceListResultDto3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IAbsenceListResultDto3 {
    data: IAbsenceDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export class AbsenceListResultDto4 implements IAbsenceListResultDto4 {
    data!: AbsenceDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: IAbsenceListResultDto4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new AbsenceDto(item) : <AbsenceDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AbsenceDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): AbsenceListResultDto4 {
        data = typeof data === 'object' ? data : {};
        let result = new AbsenceListResultDto4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IAbsenceListResultDto4 {
    data: IAbsenceDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export class EmployeeListResultDto implements IEmployeeListResultDto {
    data!: EmployeeDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: IEmployeeListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new EmployeeDto(item) : <EmployeeDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(EmployeeDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): EmployeeListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IEmployeeListResultDto {
    data: IEmployeeDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export class EmployeeProfileResultDto implements IEmployeeProfileResultDto {
    data!: EmployeeProfileDto;

    constructor(data?: IEmployeeProfileResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.data = data.data && !(<any>data.data).toJSON ? new EmployeeProfileDto(data.data) : <EmployeeProfileDto>this.data;
        }
        if (!data) {
            this.data = new EmployeeProfileDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? EmployeeProfileDto.fromJS(_data["data"]) : new EmployeeProfileDto();
        }
    }

    static fromJS(data: any): EmployeeProfileResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeProfileResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmployeeProfileResultDto {
    data: IEmployeeProfileDto;
}

export class TeamMemberListResultDto implements ITeamMemberListResultDto {
    data!: TeamMemberDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: ITeamMemberListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new TeamMemberDto(item) : <TeamMemberDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TeamMemberDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): TeamMemberListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamMemberListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface ITeamMemberListResultDto {
    data: ITeamMemberDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export class EmployeeMetaListResultDto implements IEmployeeMetaListResultDto {
    data!: EmployeeMetaDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: IEmployeeMetaListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new EmployeeMetaDto(item) : <EmployeeMetaDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(EmployeeMetaDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): EmployeeMetaListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeMetaListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IEmployeeMetaListResultDto {
    data: IEmployeeMetaDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export class PublicHolidayListResultDto implements IPublicHolidayListResultDto {
    data!: PublicHolidayDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: IPublicHolidayListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new PublicHolidayDto(item) : <PublicHolidayDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PublicHolidayDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): PublicHolidayListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublicHolidayListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IPublicHolidayListResultDto {
    data: IPublicHolidayDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export class TaskListResultDto implements ITaskListResultDto {
    data!: TaskDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: ITaskListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new TaskDto(item) : <TaskDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TaskDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): TaskListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface ITaskListResultDto {
    data: ITaskDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export class TaskCommentListResultDto implements ITaskCommentListResultDto {
    data!: TaskCommentDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: ITaskCommentListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new TaskCommentDto(item) : <TaskCommentDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TaskCommentDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): TaskCommentListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskCommentListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface ITaskCommentListResultDto {
    data: ITaskCommentDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export class TaskListResultDto2 implements ITaskListResultDto2 {
    data!: TaskDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: ITaskListResultDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new TaskDto(item) : <TaskDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TaskDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): TaskListResultDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new TaskListResultDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface ITaskListResultDto2 {
    data: ITaskDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export class TaskListResultDto3 implements ITaskListResultDto3 {
    data!: TaskDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: ITaskListResultDto3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new TaskDto(item) : <TaskDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TaskDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): TaskListResultDto3 {
        data = typeof data === 'object' ? data : {};
        let result = new TaskListResultDto3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface ITaskListResultDto3 {
    data: ITaskDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export class WorklistListResultDto implements IWorklistListResultDto {
    data!: WorklistDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: IWorklistListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new WorklistDto(item) : <WorklistDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(WorklistDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): WorklistListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorklistListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IWorklistListResultDto {
    data: IWorklistDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export class WorklistListResultDto2 implements IWorklistListResultDto2 {
    data!: WorklistDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: IWorklistListResultDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new WorklistDto(item) : <WorklistDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(WorklistDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): WorklistListResultDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new WorklistListResultDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IWorklistListResultDto2 {
    data: IWorklistDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export class TrainingListResultDto implements ITrainingListResultDto {
    data!: TrainingDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: ITrainingListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new TrainingDto(item) : <TrainingDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TrainingDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): TrainingListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface ITrainingListResultDto {
    data: ITrainingDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export class TrainingListResultDto2 implements ITrainingListResultDto2 {
    data!: TrainingDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: ITrainingListResultDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new TrainingDto(item) : <TrainingDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TrainingDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): TrainingListResultDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingListResultDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface ITrainingListResultDto2 {
    data: ITrainingDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export class TrainingListResultDto3 implements ITrainingListResultDto3 {
    data!: TrainingDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: ITrainingListResultDto3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new TrainingDto(item) : <TrainingDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TrainingDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): TrainingListResultDto3 {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingListResultDto3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface ITrainingListResultDto3 {
    data: ITrainingDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export class AnnouncementListResultDto implements IAnnouncementListResultDto {
    data!: AnnouncementDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: IAnnouncementListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new AnnouncementDto(item) : <AnnouncementDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AnnouncementDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): AnnouncementListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnnouncementListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IAnnouncementListResultDto {
    data: IAnnouncementDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export class Anonymous implements IAnonymous {
    id?: number;

    constructor(data?: IAnonymous) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Anonymous {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IAnonymous {
    id?: number;
}

export class AnniversaryListResultDto implements IAnniversaryListResultDto {
    data!: AnniversaryDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: IAnniversaryListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new AnniversaryDto(item) : <AnniversaryDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AnniversaryDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): AnniversaryListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnniversaryListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IAnniversaryListResultDto {
    data: IAnniversaryDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export class AnniversaryListResultDto2 implements IAnniversaryListResultDto2 {
    data!: AnniversaryDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: IAnniversaryListResultDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new AnniversaryDto(item) : <AnniversaryDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AnniversaryDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): AnniversaryListResultDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new AnniversaryListResultDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IAnniversaryListResultDto2 {
    data: IAnniversaryDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export class NotificationListResultDto implements INotificationListResultDto {
    data!: NotificationDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: INotificationListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new NotificationDto(item) : <NotificationDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(NotificationDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): NotificationListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface INotificationListResultDto {
    data: INotificationDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export class QuickLinkListResultDto implements IQuickLinkListResultDto {
    data!: QuickLinkDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: IQuickLinkListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new QuickLinkDto(item) : <QuickLinkDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(QuickLinkDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): QuickLinkListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuickLinkListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IQuickLinkListResultDto {
    data: IQuickLinkDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export class Anonymous2 implements IAnonymous2 {
    id?: string;

    constructor(data?: IAnonymous2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Anonymous2 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IAnonymous2 {
    id?: string;
}

export class QuickLinkListResultDto2 implements IQuickLinkListResultDto2 {
    data!: QuickLinkDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: IQuickLinkListResultDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new QuickLinkDto(item) : <QuickLinkDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(QuickLinkDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): QuickLinkListResultDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new QuickLinkListResultDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IQuickLinkListResultDto2 {
    data: IQuickLinkDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export class QuickLinkResultDto implements IQuickLinkResultDto {
    data!: QuickLinkDto;

    constructor(data?: IQuickLinkResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.data = data.data && !(<any>data.data).toJSON ? new QuickLinkDto(data.data) : <QuickLinkDto>this.data;
        }
        if (!data) {
            this.data = new QuickLinkDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? QuickLinkDto.fromJS(_data["data"]) : new QuickLinkDto();
        }
    }

    static fromJS(data: any): QuickLinkResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuickLinkResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IQuickLinkResultDto {
    data: IQuickLinkDto;
}

export class CompanyPostListResultDto implements ICompanyPostListResultDto {
    data!: CompanyPostDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: ICompanyPostListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new CompanyPostDto(item) : <CompanyPostDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CompanyPostDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): CompanyPostListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyPostListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface ICompanyPostListResultDto {
    data: ICompanyPostDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export class TimesheetShortListResultDto implements ITimesheetShortListResultDto {
    data!: TimesheetShortDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: ITimesheetShortListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new TimesheetShortDto(item) : <TimesheetShortDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TimesheetShortDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): TimesheetShortListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetShortListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface ITimesheetShortListResultDto {
    data: ITimesheetShortDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export class EvaluationSummaryListResultDto implements IEvaluationSummaryListResultDto {
    data!: EvaluationSummaryDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: IEvaluationSummaryListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new EvaluationSummaryDto(item) : <EvaluationSummaryDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(EvaluationSummaryDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): EvaluationSummaryListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EvaluationSummaryListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IEvaluationSummaryListResultDto {
    data: IEvaluationSummaryDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export class PerformanceGoalFullResultDto implements IPerformanceGoalFullResultDto {
    data!: PerformanceGoalFullDto;

    constructor(data?: IPerformanceGoalFullResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.data = data.data && !(<any>data.data).toJSON ? new PerformanceGoalFullDto(data.data) : <PerformanceGoalFullDto>this.data;
        }
        if (!data) {
            this.data = new PerformanceGoalFullDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? PerformanceGoalFullDto.fromJS(_data["data"]) : new PerformanceGoalFullDto();
        }
    }

    static fromJS(data: any): PerformanceGoalFullResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PerformanceGoalFullResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPerformanceGoalFullResultDto {
    data: IPerformanceGoalFullDto;
}

export class PerformanceGoalListResultDto implements IPerformanceGoalListResultDto {
    data!: PerformanceGoalDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: IPerformanceGoalListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new PerformanceGoalDto(item) : <PerformanceGoalDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PerformanceGoalDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): PerformanceGoalListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PerformanceGoalListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IPerformanceGoalListResultDto {
    data: IPerformanceGoalDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export class CompensationsSummaryResultDto implements ICompensationsSummaryResultDto {
    data!: CompensationsSummaryDto;

    constructor(data?: ICompensationsSummaryResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.data = data.data && !(<any>data.data).toJSON ? new CompensationsSummaryDto(data.data) : <CompensationsSummaryDto>this.data;
        }
        if (!data) {
            this.data = new CompensationsSummaryDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? CompensationsSummaryDto.fromJS(_data["data"]) : new CompensationsSummaryDto();
        }
    }

    static fromJS(data: any): CompensationsSummaryResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompensationsSummaryResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICompensationsSummaryResultDto {
    data: ICompensationsSummaryDto;
}

export class CompensationListResultDto implements ICompensationListResultDto {
    data!: CompensationDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: ICompensationListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new CompensationDto(item) : <CompensationDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CompensationDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): CompensationListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompensationListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface ICompensationListResultDto {
    data: ICompensationDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export class DevelopmentPlanResultDto implements IDevelopmentPlanResultDto {
    data!: DevelopmentPlanDto;

    constructor(data?: IDevelopmentPlanResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.data = data.data && !(<any>data.data).toJSON ? new DevelopmentPlanDto(data.data) : <DevelopmentPlanDto>this.data;
        }
        if (!data) {
            this.data = new DevelopmentPlanDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? DevelopmentPlanDto.fromJS(_data["data"]) : new DevelopmentPlanDto();
        }
    }

    static fromJS(data: any): DevelopmentPlanResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DevelopmentPlanResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDevelopmentPlanResultDto {
    data: IDevelopmentPlanDto;
}

export class EmploymentListResultDto implements IEmploymentListResultDto {
    data!: EmploymentDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: IEmploymentListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new EmploymentDto(item) : <EmploymentDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(EmploymentDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): EmploymentListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmploymentListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IEmploymentListResultDto {
    data: IEmploymentDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export enum WorklistTemplateDtoStatus {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
    DELETED = "DELETED",
}

export enum WorklistDtoStatus {
    NEW = "NEW",
    IN_PROGRESS = "IN_PROGRESS",
    COMPLETED = "COMPLETED",
    SKIPPED = "SKIPPED",
    DELETED = "DELETED",
}

export enum BulkUpdateEmployeeTasksStatusInputDtoTaskStatus {
    IN_PROGRESS = "IN_PROGRESS",
    COMPLETED = "COMPLETED",
    SKIPPED = "SKIPPED",
}

export enum Roles3 {
    ADMIN = "ADMIN",
    EMPLOYEE = "EMPLOYEE",
    MANAGER = "MANAGER",
    ALT_MANAGER = "ALT_MANAGER",
    DEPUTY_MANAGER = "DEPUTY_MANAGER",
    HR_ADMIN = "HR_ADMIN",
    HR_STAFF = "HR_STAFF",
}

export enum BulkUpdateWorklistTasksStatusInputDtoTaskStatus {
    IN_PROGRESS = "IN_PROGRESS",
    COMPLETED = "COMPLETED",
    SKIPPED = "SKIPPED",
}

export enum NotificationTargetDtoType {
    EMPLOYEE = "EMPLOYEE",
    JOB_OPENING = "JOB_OPENING",
}

export enum QuickLinkDtoLocation {
    Menu_links = "menu_links",
    Quick_links_widget = "quick_links_widget",
}

export enum QuickLinkInputDtoLocation {
    Menu_links = "menu_links",
    Quick_links_widget = "quick_links_widget",
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new SwaggerException(message, status, response, headers, result);
}